(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
const $df8eabf42bcf6038$var$randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $df8eabf42bcf6038$export$2e2bcd8739ae039 = {
    randomUUID: $df8eabf42bcf6038$var$randomUUID
};


// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let $8e9c0f3ad25e4a0c$var$getRandomValues;
const $8e9c0f3ad25e4a0c$var$rnds8 = new Uint8Array(16);
function $8e9c0f3ad25e4a0c$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$8e9c0f3ad25e4a0c$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $8e9c0f3ad25e4a0c$var$getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$8e9c0f3ad25e4a0c$var$getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return $8e9c0f3ad25e4a0c$var$getRandomValues($8e9c0f3ad25e4a0c$var$rnds8);
}


var $99a867edd452fa6a$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;


function $d958a9dc61584280$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $99a867edd452fa6a$export$2e2bcd8739ae039).test(uuid);
}
var $d958a9dc61584280$export$2e2bcd8739ae039 = $d958a9dc61584280$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const $319c0351dccf41e4$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$319c0351dccf41e4$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $319c0351dccf41e4$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return $319c0351dccf41e4$var$byteToHex[arr[offset + 0]] + $319c0351dccf41e4$var$byteToHex[arr[offset + 1]] + $319c0351dccf41e4$var$byteToHex[arr[offset + 2]] + $319c0351dccf41e4$var$byteToHex[arr[offset + 3]] + '-' + $319c0351dccf41e4$var$byteToHex[arr[offset + 4]] + $319c0351dccf41e4$var$byteToHex[arr[offset + 5]] + '-' + $319c0351dccf41e4$var$byteToHex[arr[offset + 6]] + $319c0351dccf41e4$var$byteToHex[arr[offset + 7]] + '-' + $319c0351dccf41e4$var$byteToHex[arr[offset + 8]] + $319c0351dccf41e4$var$byteToHex[arr[offset + 9]] + '-' + $319c0351dccf41e4$var$byteToHex[arr[offset + 10]] + $319c0351dccf41e4$var$byteToHex[arr[offset + 11]] + $319c0351dccf41e4$var$byteToHex[arr[offset + 12]] + $319c0351dccf41e4$var$byteToHex[arr[offset + 13]] + $319c0351dccf41e4$var$byteToHex[arr[offset + 14]] + $319c0351dccf41e4$var$byteToHex[arr[offset + 15]];
}
function $319c0351dccf41e4$var$stringify(arr, offset = 0) {
    const uuid = $319c0351dccf41e4$export$8fb373d660548968(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $d958a9dc61584280$export$2e2bcd8739ae039)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $319c0351dccf41e4$export$2e2bcd8739ae039 = $319c0351dccf41e4$var$stringify;


function $4a74e7e99c2caeb6$var$v4(options, buf, offset) {
    if ((0, $df8eabf42bcf6038$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $df8eabf42bcf6038$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, $8e9c0f3ad25e4a0c$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $319c0351dccf41e4$export$8fb373d660548968)(rnds);
}
var $4a74e7e99c2caeb6$export$2e2bcd8739ae039 = $4a74e7e99c2caeb6$var$v4;


/**
 * Common types
 *
 * @module
 */ // Explicitly defined constants are used because of Terser's inability to munge
// Typescript-generated enums
const $f50e7fcb55f78359$export$941e52d9f7cb2d = 0;
const $f50e7fcb55f78359$export$55b9edfb793fa6af = 1;
const $f50e7fcb55f78359$export$93cdbe1e4a1d4654 = 2;
const $f50e7fcb55f78359$export$6b7aa691b2b53ea0 = 3;
const $f50e7fcb55f78359$export$f03e2bcfeea63600 = 4;
const $f50e7fcb55f78359$export$4626418fce14be65 = 5;
const $f50e7fcb55f78359$export$12bd9e3412a47319 = 6;
const $f50e7fcb55f78359$export$c2fb045080e086af = 7;
const $f50e7fcb55f78359$export$cfed8745ff76e923 = 8;
const $f50e7fcb55f78359$export$259f8d0856621cd = 9;
const $f50e7fcb55f78359$export$245eccbcbac9dcf8 = 10;
const $f50e7fcb55f78359$export$327a1cd96f38a882 = 11;
const $f50e7fcb55f78359$export$6f89989572f60f10 = 12;
const $f50e7fcb55f78359$export$77a83a88485fcb44 = 13;
const $f50e7fcb55f78359$export$c95076cb2f76f866 = 14;
const $f50e7fcb55f78359$export$ea40ff6a6ead088b = 15;
const $f50e7fcb55f78359$export$ef4cf38734a1ac6a = 16;
const $f50e7fcb55f78359$export$4f2e90eea19ce64 = 17;
const $f50e7fcb55f78359$export$2991cf5fa872fe45 = 18;
const $f50e7fcb55f78359$export$c5f3025e56ccffdd = 19;
const $f50e7fcb55f78359$export$d45b5a6626e2d799 = 20;
const $f50e7fcb55f78359$export$350c6c4438936d6f = 21;
const $f50e7fcb55f78359$export$72c899c492056cc = 22;
const $f50e7fcb55f78359$export$97c749ae9b458ac4 = 23;
const $f50e7fcb55f78359$export$f995f08cb8d14b60 = 24;
const $f50e7fcb55f78359$export$e08a09aba61f8577 = 25;
const $f50e7fcb55f78359$export$6362c2d955c1b09 = 26;
const $f50e7fcb55f78359$export$f7450c06f6b28788 = 27;
const $f50e7fcb55f78359$export$b9bbcaf4a87a9d3a = 28;
var $f50e7fcb55f78359$export$afb6987cdf6e791e = /*#__PURE__*/ function(ConsoleOutputLevel) {
    /**
   * Output using `console.debug` if permitted by page settings
   */ ConsoleOutputLevel[ConsoleOutputLevel["debug"] = 0] = "debug";
    /**
   * Output using `console.error` if permitted by page settings
   */ ConsoleOutputLevel[ConsoleOutputLevel["error"] = 1] = "error";
    /**
   * Output using `console.info` if permitted by page settings
   */ ConsoleOutputLevel[ConsoleOutputLevel["info"] = 2] = "info";
    /**
   * Output using `console.warn` if permitted by page settings
   */ ConsoleOutputLevel[ConsoleOutputLevel["warn"] = 3] = "warn";
    return ConsoleOutputLevel;
}({});



/* eslint-disable @typescript-eslint/no-unnecessary-condition */ // Integer Utility
const $e57213ff891a4509$export$3314b2c271c86d70 = 0xffffffff;
function $e57213ff891a4509$export$20f71c4c8b0f96c3(view, offset, value) {
    const high = value / 0x100000000;
    const low = value // high bits are truncated by DataView
    ;
    view.setUint32(offset, high);
    view.setUint32(offset + 4, low);
}
function $e57213ff891a4509$export$8532a5209571c04a(view, offset, value) {
    const high = Math.floor(value / 0x100000000);
    const low = value // high bits are truncated by DataView
    ;
    view.setUint32(offset, high);
    view.setUint32(offset + 4, low);
}
function $e57213ff891a4509$export$69825c7adcc820c6(view, offset) {
    const high = view.getInt32(offset);
    const low = view.getUint32(offset + 4);
    return high * 0x100000000 + low;
}
function $e57213ff891a4509$export$59a2dbf579ff9568(view, offset) {
    const high = view.getUint32(offset);
    const low = view.getUint32(offset + 4);
    return high * 0x100000000 + low;
}


var $851085fe3b0750dc$exports = {};
// shim for using process in browser
var $851085fe3b0750dc$var$process = $851085fe3b0750dc$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $851085fe3b0750dc$var$cachedSetTimeout;
var $851085fe3b0750dc$var$cachedClearTimeout;
function $851085fe3b0750dc$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $851085fe3b0750dc$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $851085fe3b0750dc$var$cachedSetTimeout = setTimeout;
        else $851085fe3b0750dc$var$cachedSetTimeout = $851085fe3b0750dc$var$defaultSetTimout;
    } catch (e) {
        $851085fe3b0750dc$var$cachedSetTimeout = $851085fe3b0750dc$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $851085fe3b0750dc$var$cachedClearTimeout = clearTimeout;
        else $851085fe3b0750dc$var$cachedClearTimeout = $851085fe3b0750dc$var$defaultClearTimeout;
    } catch (e) {
        $851085fe3b0750dc$var$cachedClearTimeout = $851085fe3b0750dc$var$defaultClearTimeout;
    }
})();
function $851085fe3b0750dc$var$runTimeout(fun) {
    if ($851085fe3b0750dc$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($851085fe3b0750dc$var$cachedSetTimeout === $851085fe3b0750dc$var$defaultSetTimout || !$851085fe3b0750dc$var$cachedSetTimeout) && setTimeout) {
        $851085fe3b0750dc$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $851085fe3b0750dc$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $851085fe3b0750dc$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $851085fe3b0750dc$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $851085fe3b0750dc$var$runClearTimeout(marker) {
    if ($851085fe3b0750dc$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($851085fe3b0750dc$var$cachedClearTimeout === $851085fe3b0750dc$var$defaultClearTimeout || !$851085fe3b0750dc$var$cachedClearTimeout) && clearTimeout) {
        $851085fe3b0750dc$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $851085fe3b0750dc$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $851085fe3b0750dc$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $851085fe3b0750dc$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $851085fe3b0750dc$var$queue = [];
var $851085fe3b0750dc$var$draining = false;
var $851085fe3b0750dc$var$currentQueue;
var $851085fe3b0750dc$var$queueIndex = -1;
function $851085fe3b0750dc$var$cleanUpNextTick() {
    if (!$851085fe3b0750dc$var$draining || !$851085fe3b0750dc$var$currentQueue) return;
    $851085fe3b0750dc$var$draining = false;
    if ($851085fe3b0750dc$var$currentQueue.length) $851085fe3b0750dc$var$queue = $851085fe3b0750dc$var$currentQueue.concat($851085fe3b0750dc$var$queue);
    else $851085fe3b0750dc$var$queueIndex = -1;
    if ($851085fe3b0750dc$var$queue.length) $851085fe3b0750dc$var$drainQueue();
}
function $851085fe3b0750dc$var$drainQueue() {
    if ($851085fe3b0750dc$var$draining) return;
    var timeout = $851085fe3b0750dc$var$runTimeout($851085fe3b0750dc$var$cleanUpNextTick);
    $851085fe3b0750dc$var$draining = true;
    var len = $851085fe3b0750dc$var$queue.length;
    while(len){
        $851085fe3b0750dc$var$currentQueue = $851085fe3b0750dc$var$queue;
        $851085fe3b0750dc$var$queue = [];
        while(++$851085fe3b0750dc$var$queueIndex < len)if ($851085fe3b0750dc$var$currentQueue) $851085fe3b0750dc$var$currentQueue[$851085fe3b0750dc$var$queueIndex].run();
        $851085fe3b0750dc$var$queueIndex = -1;
        len = $851085fe3b0750dc$var$queue.length;
    }
    $851085fe3b0750dc$var$currentQueue = null;
    $851085fe3b0750dc$var$draining = false;
    $851085fe3b0750dc$var$runClearTimeout(timeout);
}
$851085fe3b0750dc$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $851085fe3b0750dc$var$queue.push(new $851085fe3b0750dc$var$Item(fun, args));
    if ($851085fe3b0750dc$var$queue.length === 1 && !$851085fe3b0750dc$var$draining) $851085fe3b0750dc$var$runTimeout($851085fe3b0750dc$var$drainQueue);
};
// v8 likes predictible objects
function $851085fe3b0750dc$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$851085fe3b0750dc$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$851085fe3b0750dc$var$process.title = 'browser';
$851085fe3b0750dc$var$process.browser = true;
$851085fe3b0750dc$var$process.env = {};
$851085fe3b0750dc$var$process.argv = [];
$851085fe3b0750dc$var$process.version = ''; // empty string to avoid regexp issues
$851085fe3b0750dc$var$process.versions = {};
function $851085fe3b0750dc$var$noop() {}
$851085fe3b0750dc$var$process.on = $851085fe3b0750dc$var$noop;
$851085fe3b0750dc$var$process.addListener = $851085fe3b0750dc$var$noop;
$851085fe3b0750dc$var$process.once = $851085fe3b0750dc$var$noop;
$851085fe3b0750dc$var$process.off = $851085fe3b0750dc$var$noop;
$851085fe3b0750dc$var$process.removeListener = $851085fe3b0750dc$var$noop;
$851085fe3b0750dc$var$process.removeAllListeners = $851085fe3b0750dc$var$noop;
$851085fe3b0750dc$var$process.emit = $851085fe3b0750dc$var$noop;
$851085fe3b0750dc$var$process.prependListener = $851085fe3b0750dc$var$noop;
$851085fe3b0750dc$var$process.prependOnceListener = $851085fe3b0750dc$var$noop;
$851085fe3b0750dc$var$process.listeners = function(name) {
    return [];
};
$851085fe3b0750dc$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$851085fe3b0750dc$var$process.cwd = function() {
    return '/';
};
$851085fe3b0750dc$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$851085fe3b0750dc$var$process.umask = function() {
    return 0;
};


const $e4084b2505cad976$var$TEXT_ENCODING_AVAILABLE = (typeof (0, (/*@__PURE__*/$parcel$interopDefault($851085fe3b0750dc$exports))) === "undefined" || (0, (/*@__PURE__*/$parcel$interopDefault($851085fe3b0750dc$exports)))?.env?.TEXT_ENCODING !== "never") && typeof TextEncoder !== "undefined" && typeof TextDecoder !== "undefined";
function $e4084b2505cad976$export$b61de95301265227(str) {
    const strLength = str.length;
    let byteLength = 0;
    let pos = 0;
    while(pos < strLength){
        let value = str.charCodeAt(pos++);
        if ((value & 0xffffff80) === 0) {
            // 1-byte
            byteLength++;
            continue;
        } else if ((value & 0xfffff800) === 0) // 2-bytes
        byteLength += 2;
        else {
            // handle surrogate pair
            if (value >= 0xd800 && value <= 0xdbff) // high surrogate
            {
                if (pos < strLength) {
                    const extra = str.charCodeAt(pos);
                    if ((extra & 0xfc00) === 0xdc00) {
                        ++pos;
                        value = ((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000;
                    }
                }
            }
            if ((value & 0xffff0000) === 0) // 3-byte
            byteLength += 3;
            else // 4-byte
            byteLength += 4;
        }
    }
    return byteLength;
}
function $e4084b2505cad976$export$1042e4338f1ef853(str, output, outputOffset) {
    const strLength = str.length;
    let offset = outputOffset;
    let pos = 0;
    while(pos < strLength){
        let value = str.charCodeAt(pos++);
        if ((value & 0xffffff80) === 0) {
            // 1-byte
            output[offset++] = value;
            continue;
        } else if ((value & 0xfffff800) === 0) // 2-bytes
        output[offset++] = value >> 6 & 0x1f | 0xc0;
        else {
            // handle surrogate pair
            if (value >= 0xd800 && value <= 0xdbff) // high surrogate
            {
                if (pos < strLength) {
                    const extra = str.charCodeAt(pos);
                    if ((extra & 0xfc00) === 0xdc00) {
                        ++pos;
                        value = ((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000;
                    }
                }
            }
            if ((value & 0xffff0000) === 0) {
                // 3-byte
                output[offset++] = value >> 12 & 0x0f | 0xe0;
                output[offset++] = value >> 6 & 0x3f | 0x80;
            } else {
                // 4-byte
                output[offset++] = value >> 18 & 0x07 | 0xf0;
                output[offset++] = value >> 12 & 0x3f | 0x80;
                output[offset++] = value >> 6 & 0x3f | 0x80;
            }
        }
        output[offset++] = value & 0x3f | 0x80;
    }
}
const $e4084b2505cad976$var$sharedTextEncoder = $e4084b2505cad976$var$TEXT_ENCODING_AVAILABLE ? new TextEncoder() : undefined;
const $e4084b2505cad976$export$ed34c0622b397238 = !$e4084b2505cad976$var$TEXT_ENCODING_AVAILABLE ? (0, $e57213ff891a4509$export$3314b2c271c86d70) : typeof (0, (/*@__PURE__*/$parcel$interopDefault($851085fe3b0750dc$exports))) !== "undefined" && (0, (/*@__PURE__*/$parcel$interopDefault($851085fe3b0750dc$exports)))?.env?.TEXT_ENCODING !== "force" ? 200 : 0;
function $e4084b2505cad976$var$utf8EncodeTEencode(str, output, outputOffset) {
    output.set($e4084b2505cad976$var$sharedTextEncoder.encode(str), outputOffset);
}
function $e4084b2505cad976$var$utf8EncodeTEencodeInto(str, output, outputOffset) {
    $e4084b2505cad976$var$sharedTextEncoder.encodeInto(str, output.subarray(outputOffset));
}
const $e4084b2505cad976$export$34cfdc82d430524 = $e4084b2505cad976$var$sharedTextEncoder?.encodeInto ? $e4084b2505cad976$var$utf8EncodeTEencodeInto : $e4084b2505cad976$var$utf8EncodeTEencode;
const $e4084b2505cad976$var$CHUNK_SIZE = 0x1000;
function $e4084b2505cad976$export$551117984c2adf4f(bytes, inputOffset, byteLength) {
    let offset = inputOffset;
    const end = offset + byteLength;
    const units = [];
    let result = "";
    while(offset < end){
        const byte1 = bytes[offset++];
        if ((byte1 & 0x80) === 0) // 1 byte
        units.push(byte1);
        else if ((byte1 & 0xe0) === 0xc0) {
            // 2 bytes
            const byte2 = bytes[offset++] & 0x3f;
            units.push((byte1 & 0x1f) << 6 | byte2);
        } else if ((byte1 & 0xf0) === 0xe0) {
            // 3 bytes
            const byte2 = bytes[offset++] & 0x3f;
            const byte3 = bytes[offset++] & 0x3f;
            units.push((byte1 & 0x1f) << 12 | byte2 << 6 | byte3);
        } else if ((byte1 & 0xf8) === 0xf0) {
            // 4 bytes
            const byte2 = bytes[offset++] & 0x3f;
            const byte3 = bytes[offset++] & 0x3f;
            const byte4 = bytes[offset++] & 0x3f;
            let unit = (byte1 & 0x07) << 0x12 | byte2 << 0x0c | byte3 << 0x06 | byte4;
            if (unit > 0xffff) {
                unit -= 0x10000;
                units.push(unit >>> 10 & 0x3ff | 0xd800);
                unit = 0xdc00 | unit & 0x3ff;
            }
            units.push(unit);
        } else units.push(byte1);
        if (units.length >= $e4084b2505cad976$var$CHUNK_SIZE) {
            result += String.fromCharCode(...units);
            units.length = 0;
        }
    }
    if (units.length > 0) result += String.fromCharCode(...units);
    return result;
}
const $e4084b2505cad976$var$sharedTextDecoder = $e4084b2505cad976$var$TEXT_ENCODING_AVAILABLE ? new TextDecoder() : null;
const $e4084b2505cad976$export$d866281c5a66d1ef = !$e4084b2505cad976$var$TEXT_ENCODING_AVAILABLE ? (0, $e57213ff891a4509$export$3314b2c271c86d70) : typeof (0, (/*@__PURE__*/$parcel$interopDefault($851085fe3b0750dc$exports))) !== "undefined" && (0, (/*@__PURE__*/$parcel$interopDefault($851085fe3b0750dc$exports)))?.env?.TEXT_DECODER !== "force" ? 200 : 0;
function $e4084b2505cad976$export$6ed79e41309992dc(bytes, inputOffset, byteLength) {
    const stringBytes = bytes.subarray(inputOffset, inputOffset + byteLength);
    return $e4084b2505cad976$var$sharedTextDecoder.decode(stringBytes);
}


// ExtensionCodec to handle MessagePack extensions
/**
 * ExtData is used to handle Extension Types that are not registered to ExtensionCodec.
 */ class $1d9a363f3014a44e$export$bcbeb236456bc779 {
    constructor(type, data){
        this.type = type;
        this.data = data;
    }
}


// https://github.com/msgpack/msgpack/blob/master/spec.md#timestamp-extension-type
class $33cfc2c485ea092e$export$ef3eed12d06c0285 extends Error {
    constructor(message){
        super(message);
        // fix the prototype chain in a cross-platform way
        const proto = Object.create($33cfc2c485ea092e$export$ef3eed12d06c0285.prototype);
        Object.setPrototypeOf(this, proto);
        Object.defineProperty(this, "name", {
            configurable: true,
            enumerable: false,
            value: $33cfc2c485ea092e$export$ef3eed12d06c0285.name
        });
    }
}



const $1556632f4be66883$export$f18369fc203f4e13 = -1;
const $1556632f4be66883$var$TIMESTAMP32_MAX_SEC = 4294967295 // 32-bit unsigned int
;
const $1556632f4be66883$var$TIMESTAMP64_MAX_SEC = 17179869183 // 34-bit unsigned int
;
function $1556632f4be66883$export$2fd05b828dd81159({ sec: sec, nsec: nsec }) {
    if (sec >= 0 && nsec >= 0 && sec <= $1556632f4be66883$var$TIMESTAMP64_MAX_SEC) {
        // Here sec >= 0 && nsec >= 0
        if (nsec === 0 && sec <= $1556632f4be66883$var$TIMESTAMP32_MAX_SEC) {
            // timestamp 32 = { sec32 (unsigned) }
            const rv = new Uint8Array(4);
            const view = new DataView(rv.buffer);
            view.setUint32(0, sec);
            return rv;
        } else {
            // timestamp 64 = { nsec30 (unsigned), sec34 (unsigned) }
            const secHigh = sec / 0x100000000;
            const secLow = sec & 0xffffffff;
            const rv = new Uint8Array(8);
            const view = new DataView(rv.buffer);
            // nsec30 | secHigh2
            view.setUint32(0, nsec << 2 | secHigh & 0x3);
            // secLow32
            view.setUint32(4, secLow);
            return rv;
        }
    } else {
        // timestamp 96 = { nsec32 (unsigned), sec64 (signed) }
        const rv = new Uint8Array(12);
        const view = new DataView(rv.buffer);
        view.setUint32(0, nsec);
        (0, $e57213ff891a4509$export$8532a5209571c04a)(view, 4, sec);
        return rv;
    }
}
function $1556632f4be66883$export$221d97b3b00b03c2(date) {
    const msec = date.getTime();
    const sec = Math.floor(msec / 1e3);
    const nsec = (msec - sec * 1e3) * 1e6;
    // Normalizes { sec, nsec } to ensure nsec is unsigned.
    const nsecInSec = Math.floor(nsec / 1e9);
    return {
        sec: sec + nsecInSec,
        nsec: nsec - nsecInSec * 1e9
    };
}
function $1556632f4be66883$export$32420f352fe0fc83(object) {
    if (object instanceof Date) {
        const timeSpec = $1556632f4be66883$export$221d97b3b00b03c2(object);
        return $1556632f4be66883$export$2fd05b828dd81159(timeSpec);
    } else return null;
}
function $1556632f4be66883$export$abfc8800a5159711(data) {
    const view = new DataView(data.buffer, data.byteOffset, data.byteLength);
    // data may be 32, 64, or 96 bits
    switch(data.byteLength){
        case 4:
            {
                // timestamp 32 = { sec32 }
                const sec = view.getUint32(0);
                const nsec = 0;
                return {
                    sec: sec,
                    nsec: nsec
                };
            }
        case 8:
            {
                // timestamp 64 = { nsec30, sec34 }
                const nsec30AndSecHigh2 = view.getUint32(0);
                const secLow32 = view.getUint32(4);
                const sec = (nsec30AndSecHigh2 & 0x3) * 0x100000000 + secLow32;
                const nsec = nsec30AndSecHigh2 >>> 2;
                return {
                    sec: sec,
                    nsec: nsec
                };
            }
        case 12:
            {
                // timestamp 96 = { nsec32 (unsigned), sec64 (signed) }
                const sec = (0, $e57213ff891a4509$export$69825c7adcc820c6)(view, 4);
                const nsec = view.getUint32(0);
                return {
                    sec: sec,
                    nsec: nsec
                };
            }
        default:
            throw new (0, $33cfc2c485ea092e$export$ef3eed12d06c0285)(`Unrecognized data size for timestamp (expected 4, 8, or 12): ${data.length}`);
    }
}
function $1556632f4be66883$export$80b8ff9315e4298f(data) {
    const timeSpec = $1556632f4be66883$export$abfc8800a5159711(data);
    return new Date(timeSpec.sec * 1e3 + timeSpec.nsec / 1e6);
}
const $1556632f4be66883$export$8654479533463da1 = {
    type: $1556632f4be66883$export$f18369fc203f4e13,
    encode: $1556632f4be66883$export$32420f352fe0fc83,
    decode: $1556632f4be66883$export$80b8ff9315e4298f
};


class $2230d60a1bef7744$export$12677a794dbd89d7 {
    static{
        this.defaultCodec = new $2230d60a1bef7744$export$12677a794dbd89d7();
    }
    constructor(){
        // built-in extensions
        this.builtInEncoders = [];
        this.builtInDecoders = [];
        // custom extensions
        this.encoders = [];
        this.decoders = [];
        this.register((0, $1556632f4be66883$export$8654479533463da1));
    }
    register({ type: type, encode: encode, decode: decode }) {
        if (type >= 0) {
            // custom extensions
            this.encoders[type] = encode;
            this.decoders[type] = decode;
        } else {
            // built-in extensions
            const index = 1 + type;
            this.builtInEncoders[index] = encode;
            this.builtInDecoders[index] = decode;
        }
    }
    tryToEncode(object, context) {
        // built-in extensions
        for(let i = 0; i < this.builtInEncoders.length; i++){
            const encodeExt = this.builtInEncoders[i];
            if (encodeExt != null) {
                const data = encodeExt(object, context);
                if (data != null) {
                    const type = -1 - i;
                    return new (0, $1d9a363f3014a44e$export$bcbeb236456bc779)(type, data);
                }
            }
        }
        // custom extensions
        for(let i = 0; i < this.encoders.length; i++){
            const encodeExt = this.encoders[i];
            if (encodeExt != null) {
                const data = encodeExt(object, context);
                if (data != null) {
                    const type = i;
                    return new (0, $1d9a363f3014a44e$export$bcbeb236456bc779)(type, data);
                }
            }
        }
        if (object instanceof (0, $1d9a363f3014a44e$export$bcbeb236456bc779)) // to keep ExtData as is
        return object;
        return null;
    }
    decode(data, type, context) {
        const decodeExt = type < 0 ? this.builtInDecoders[-1 - type] : this.decoders[type];
        if (decodeExt) return decodeExt(data, type, context);
        else // decode() does not fail, returns ExtData instead.
        return new (0, $1d9a363f3014a44e$export$bcbeb236456bc779)(type, data);
    }
}



function $0d53962f89c9e79a$export$f8d669c2a17882f2(buffer) {
    if (buffer instanceof Uint8Array) return buffer;
    else if (ArrayBuffer.isView(buffer)) return new Uint8Array(buffer.buffer, buffer.byteOffset, buffer.byteLength);
    else if (buffer instanceof ArrayBuffer) return new Uint8Array(buffer);
    else // ArrayLike<number>
    return Uint8Array.from(buffer);
}
function $0d53962f89c9e79a$export$7277868462c1ba02(buffer) {
    if (buffer instanceof ArrayBuffer) return new DataView(buffer);
    const bufferView = $0d53962f89c9e79a$export$f8d669c2a17882f2(buffer);
    return new DataView(bufferView.buffer, bufferView.byteOffset, bufferView.byteLength);
}


const $7681abeee69a3316$export$2c6de1218fe0e46d = 100;
const $7681abeee69a3316$export$29659805a45f979c = 2048;
class $7681abeee69a3316$export$a50aceb0e02a00aa {
    constructor(extensionCodec = (0, $2230d60a1bef7744$export$12677a794dbd89d7).defaultCodec, context, maxDepth = $7681abeee69a3316$export$2c6de1218fe0e46d, // private readonly initialBufferSize = DEFAULT_INITIAL_BUFFER_SIZE,
    sortKeys = false, forceFloat32 = false, ignoreUndefined = false, forceIntegerToFloat = false){
        this.extensionCodec = extensionCodec;
        this.context = context;
        this.maxDepth = maxDepth;
        this.sortKeys = sortKeys;
        this.forceFloat32 = forceFloat32;
        this.ignoreUndefined = ignoreUndefined;
        this.forceIntegerToFloat = forceIntegerToFloat;
        this.pos = 0;
        this.view = new DataView(new ArrayBuffer($7681abeee69a3316$export$29659805a45f979c));
        this.bytes = new Uint8Array(this.view.buffer);
    }
    reinitializeState() {
        this.pos = 0;
    }
    /**
   * This is almost equivalent to {@link Encoder#encode}, but it returns an reference of the encoder's internal buffer and thus much faster than {@link Encoder#encode}.
   *
   * @returns Encodes the object and returns a shared reference the encoder's internal buffer.
   */ encodeSharedRef(object) {
        this.reinitializeState();
        this.doEncode(object, 1);
        return this.bytes.subarray(0, this.pos);
    }
    /**
   * @returns Encodes the object and returns a copy of the encoder's internal buffer.
   */ encode(object) {
        this.reinitializeState();
        this.doEncode(object, 1);
        return this.bytes.slice(0, this.pos);
    }
    doEncode(object, depth) {
        if (depth > this.maxDepth) throw new Error(`Too deep objects in depth ${depth}`);
        if (object == null) this.encodeNil();
        else if (typeof object === "boolean") this.encodeBoolean(object);
        else if (typeof object === "number") this.encodeNumber(object);
        else if (typeof object === "string") this.encodeString(object);
        else this.encodeObject(object, depth);
    }
    ensureBufferSizeToWrite(sizeToWrite) {
        const requiredSize = this.pos + sizeToWrite;
        if (this.view.byteLength < requiredSize) this.resizeBuffer(requiredSize * 2);
    }
    resizeBuffer(newSize) {
        const newBuffer = new ArrayBuffer(newSize);
        const newBytes = new Uint8Array(newBuffer);
        const newView = new DataView(newBuffer);
        newBytes.set(this.bytes);
        this.view = newView;
        this.bytes = newBytes;
    }
    encodeNil() {
        this.writeU8(0xc0);
    }
    encodeBoolean(object) {
        if (object === false) this.writeU8(0xc2);
        else this.writeU8(0xc3);
    }
    encodeNumber(object) {
        if (Number.isSafeInteger(object) && !this.forceIntegerToFloat) {
            if (object >= 0) {
                if (object < 0x80) // positive fixint
                this.writeU8(object);
                else if (object < 0x100) {
                    // uint 8
                    this.writeU8(0xcc);
                    this.writeU8(object);
                } else if (object < 0x10000) {
                    // uint 16
                    this.writeU8(0xcd);
                    this.writeU16(object);
                } else if (object < 0x100000000) {
                    // uint 32
                    this.writeU8(0xce);
                    this.writeU32(object);
                } else {
                    // uint 64
                    this.writeU8(0xcf);
                    this.writeU64(object);
                }
            } else {
                if (object >= -32) // negative fixint
                this.writeU8(0xe0 | object + 0x20);
                else if (object >= -128) {
                    // int 8
                    this.writeU8(0xd0);
                    this.writeI8(object);
                } else if (object >= -32768) {
                    // int 16
                    this.writeU8(0xd1);
                    this.writeI16(object);
                } else if (object >= -2147483648) {
                    // int 32
                    this.writeU8(0xd2);
                    this.writeI32(object);
                } else {
                    // int 64
                    this.writeU8(0xd3);
                    this.writeI64(object);
                }
            }
        } else // non-integer numbers
        if (this.forceFloat32) {
            // float 32
            this.writeU8(0xca);
            this.writeF32(object);
        } else {
            // float 64
            this.writeU8(0xcb);
            this.writeF64(object);
        }
    }
    writeStringHeader(byteLength) {
        if (byteLength < 32) // fixstr
        this.writeU8(0xa0 + byteLength);
        else if (byteLength < 0x100) {
            // str 8
            this.writeU8(0xd9);
            this.writeU8(byteLength);
        } else if (byteLength < 0x10000) {
            // str 16
            this.writeU8(0xda);
            this.writeU16(byteLength);
        } else if (byteLength < 0x100000000) {
            // str 32
            this.writeU8(0xdb);
            this.writeU32(byteLength);
        } else throw new Error(`Too long string: ${byteLength} bytes in UTF-8`);
    }
    encodeString(object) {
        const maxHeaderSize = 5;
        const strLength = object.length;
        if (strLength > (0, $e4084b2505cad976$export$ed34c0622b397238)) {
            const byteLength = (0, $e4084b2505cad976$export$b61de95301265227)(object);
            this.ensureBufferSizeToWrite(maxHeaderSize + byteLength);
            this.writeStringHeader(byteLength);
            (0, $e4084b2505cad976$export$34cfdc82d430524)(object, this.bytes, this.pos);
            this.pos += byteLength;
        } else {
            const byteLength = (0, $e4084b2505cad976$export$b61de95301265227)(object);
            this.ensureBufferSizeToWrite(maxHeaderSize + byteLength);
            this.writeStringHeader(byteLength);
            (0, $e4084b2505cad976$export$1042e4338f1ef853)(object, this.bytes, this.pos);
            this.pos += byteLength;
        }
    }
    encodeObject(object, depth) {
        // try to encode objects with custom codec first of non-primitives
        const ext = this.extensionCodec.tryToEncode(object, this.context);
        if (ext != null) this.encodeExtension(ext);
        else if (Array.isArray(object)) this.encodeArray(object, depth);
        else if (ArrayBuffer.isView(object)) this.encodeBinary(object);
        else if (typeof object === "object") this.encodeMap(object, depth);
        else // symbol, function and other special object come here unless extensionCodec handles them.
        throw new Error(`Unrecognized object: ${Object.prototype.toString.apply(object)}`);
    }
    encodeBinary(object) {
        const size = object.byteLength;
        if (size < 0x100) {
            // bin 8
            this.writeU8(0xc4);
            this.writeU8(size);
        } else if (size < 0x10000) {
            // bin 16
            this.writeU8(0xc5);
            this.writeU16(size);
        } else if (size < 0x100000000) {
            // bin 32
            this.writeU8(0xc6);
            this.writeU32(size);
        } else throw new Error(`Too large binary: ${size}`);
        const bytes = (0, $0d53962f89c9e79a$export$f8d669c2a17882f2)(object);
        this.writeU8a(bytes);
    }
    encodeArray(object, depth) {
        const size = object.length;
        if (size < 16) // fixarray
        this.writeU8(0x90 + size);
        else if (size < 0x10000) {
            // array 16
            this.writeU8(0xdc);
            this.writeU16(size);
        } else if (size < 0x100000000) {
            // array 32
            this.writeU8(0xdd);
            this.writeU32(size);
        } else throw new Error(`Too large array: ${size}`);
        for (const item of object)this.doEncode(item, depth + 1);
    }
    countWithoutUndefined(object, keys) {
        let count = 0;
        for (const key of keys)if (object[key] !== undefined) count++;
        return count;
    }
    encodeMap(object, depth) {
        const keys = Object.keys(object);
        if (this.sortKeys) keys.sort();
        const size = this.ignoreUndefined ? this.countWithoutUndefined(object, keys) : keys.length;
        if (size < 16) // fixmap
        this.writeU8(0x80 + size);
        else if (size < 0x10000) {
            // map 16
            this.writeU8(0xde);
            this.writeU16(size);
        } else if (size < 0x100000000) {
            // map 32
            this.writeU8(0xdf);
            this.writeU32(size);
        } else throw new Error(`Too large map object: ${size}`);
        for (const key of keys){
            const value = object[key];
            if (!(this.ignoreUndefined && value === undefined)) {
                this.encodeString(key);
                this.doEncode(value, depth + 1);
            }
        }
    }
    encodeExtension(ext) {
        const size = ext.data.length;
        if (size === 1) // fixext 1
        this.writeU8(0xd4);
        else if (size === 2) // fixext 2
        this.writeU8(0xd5);
        else if (size === 4) // fixext 4
        this.writeU8(0xd6);
        else if (size === 8) // fixext 8
        this.writeU8(0xd7);
        else if (size === 16) // fixext 16
        this.writeU8(0xd8);
        else if (size < 0x100) {
            // ext 8
            this.writeU8(0xc7);
            this.writeU8(size);
        } else if (size < 0x10000) {
            // ext 16
            this.writeU8(0xc8);
            this.writeU16(size);
        } else if (size < 0x100000000) {
            // ext 32
            this.writeU8(0xc9);
            this.writeU32(size);
        } else throw new Error(`Too large extension object: ${size}`);
        this.writeI8(ext.type);
        this.writeU8a(ext.data);
    }
    writeU8(value) {
        this.ensureBufferSizeToWrite(1);
        this.view.setUint8(this.pos, value);
        this.pos++;
    }
    writeU8a(values) {
        const size = values.length;
        this.ensureBufferSizeToWrite(size);
        this.bytes.set(values, this.pos);
        this.pos += size;
    }
    writeI8(value) {
        this.ensureBufferSizeToWrite(1);
        this.view.setInt8(this.pos, value);
        this.pos++;
    }
    writeU16(value) {
        this.ensureBufferSizeToWrite(2);
        this.view.setUint16(this.pos, value);
        this.pos += 2;
    }
    writeI16(value) {
        this.ensureBufferSizeToWrite(2);
        this.view.setInt16(this.pos, value);
        this.pos += 2;
    }
    writeU32(value) {
        this.ensureBufferSizeToWrite(4);
        this.view.setUint32(this.pos, value);
        this.pos += 4;
    }
    writeI32(value) {
        this.ensureBufferSizeToWrite(4);
        this.view.setInt32(this.pos, value);
        this.pos += 4;
    }
    writeF32(value) {
        this.ensureBufferSizeToWrite(4);
        this.view.setFloat32(this.pos, value);
        this.pos += 4;
    }
    writeF64(value) {
        this.ensureBufferSizeToWrite(8);
        this.view.setFloat64(this.pos, value);
        this.pos += 8;
    }
    writeU64(value) {
        this.ensureBufferSizeToWrite(8);
        (0, $e57213ff891a4509$export$20f71c4c8b0f96c3)(this.view, this.pos, value);
        this.pos += 8;
    }
    writeI64(value) {
        this.ensureBufferSizeToWrite(8);
        (0, $e57213ff891a4509$export$8532a5209571c04a)(this.view, this.pos, value);
        this.pos += 8;
    }
}


const $35ac4885fa0e8013$var$defaultEncodeOptions = {};
function $35ac4885fa0e8013$export$c564cdbbe6da493(value, options = $35ac4885fa0e8013$var$defaultEncodeOptions) {
    const encoder = new (0, $7681abeee69a3316$export$a50aceb0e02a00aa)(options.extensionCodec, options.context, options.maxDepth, // options.initialBufferSize,
    options.sortKeys, options.forceFloat32, options.ignoreUndefined, options.forceIntegerToFloat);
    return encoder.encodeSharedRef(value);
}


const $2945e13ce7899c45$export$f5922988a7d5ce84 = (d, v)=>new $2945e13ce7899c45$var$ApplicationEventsImpl(d, v);
class $2945e13ce7899c45$var$ApplicationEventsImpl {
    constructor(_dependencies, _clientVersion){
        this._dependencies = _dependencies;
        this._clientVersion = _clientVersion;
        this._clientInitializationRecorded = false;
        this._applicationEventLoggingEndpointBase = null;
        this._afterMeasurementBeaconEvents = [];
        this._afterSessionConfigDownloadEvents = [];
        this._afterTestObjectDownloadEvents = [];
        this._beforeMeasurementBeaconEvents = [];
        this._beforeSessionConfigDownloadEvents = [];
        this._beforeTestObjectDownloadEvents = [];
        this._clientInitializedEvent = null;
        this._measurementBeaconErrorEvents = [];
        this._sessionConfigDownloadErrorEvents = [];
    }
    _resetEventState() {
        this._dependencies.outputToConsole((0, $f50e7fcb55f78359$export$afb6987cdf6e791e).debug, ()=>"Resetting application event state");
        this._afterMeasurementBeaconEvents = [];
        this._afterSessionConfigDownloadEvents = [];
        this._afterTestObjectDownloadEvents = [];
        this._beforeMeasurementBeaconEvents = [];
        this._beforeSessionConfigDownloadEvents = [];
        this._beforeTestObjectDownloadEvents = [];
        this._clientInitializedEvent = null;
        this._measurementBeaconErrorEvents = [];
        this._sessionConfigDownloadErrorEvents = [];
    }
    get applicationEventLoggingEndpointBase() {
        return this._applicationEventLoggingEndpointBase;
    }
    set applicationEventLoggingEndpointBase(value) {
        this._applicationEventLoggingEndpointBase = value;
    }
    beacon() {
        const isNonZeroLoggingInterval = ()=>typeof this._dependencies.runtimeValues.applicationEventsBeaconIntervalInMilliseconds === "number" ? 0 < this._dependencies.runtimeValues.applicationEventsBeaconIntervalInMilliseconds : false;
        // Go through the motions even if the client isn't configured for
        // logging to free memory.
        const reportableEventCount = this._afterMeasurementBeaconEvents.length + this._afterSessionConfigDownloadEvents.length + this._afterTestObjectDownloadEvents.length + this._beforeMeasurementBeaconEvents.length + this._beforeSessionConfigDownloadEvents.length + this._beforeTestObjectDownloadEvents.length + (this._clientInitializedEvent ? 1 : 0) + this._measurementBeaconErrorEvents.length + this._sessionConfigDownloadErrorEvents.length;
        if (reportableEventCount) {
            if (this._applicationEventLoggingEndpointBase && isNonZeroLoggingInterval()) {
                const payload = [
                    1,
                    1,
                    this._clientVersion,
                    this._beforeTestObjectDownloadEvents,
                    this._afterTestObjectDownloadEvents,
                    this._beforeMeasurementBeaconEvents,
                    this._afterMeasurementBeaconEvents,
                    this._measurementBeaconErrorEvents,
                    this._beforeSessionConfigDownloadEvents,
                    this._afterSessionConfigDownloadEvents,
                    this._sessionConfigDownloadErrorEvents,
                    this._clientInitializedEvent
                ];
                this._dependencies.outputToConsole((0, $f50e7fcb55f78359$export$afb6987cdf6e791e).debug, ()=>`Client event data: ${JSON.stringify(payload)}`);
                this._dependencies.callSendBeaconWithData((0, $f50e7fcb55f78359$export$941e52d9f7cb2d), new URL("/v1", this._applicationEventLoggingEndpointBase).href, (0, $35ac4885fa0e8013$export$c564cdbbe6da493)(payload));
            }
            this._resetEventState();
        } else this._dependencies.outputToConsole((0, $f50e7fcb55f78359$export$afb6987cdf6e791e).debug, ()=>"No application events to report");
    }
    recordAfterMeasurementBeaconEvent(epochTimestamp, runtimeValues, duration) {
        this._afterMeasurementBeaconEvents.push([
            epochTimestamp,
            ...$2945e13ce7899c45$export$d349f2f4b9260407(runtimeValues),
            duration
        ]);
    }
    recordAfterSessionConfigDownloadEvent(epochTimestamp, runtimeValues, duration) {
        this._afterSessionConfigDownloadEvents.push([
            epochTimestamp,
            ...$2945e13ce7899c45$export$d349f2f4b9260407(runtimeValues),
            duration
        ]);
    }
    recordAfterTestObjectDownloadEvent(epochTimestamp, runtimeValues, testObjectConfig, duration) {
        this._afterTestObjectDownloadEvents.push([
            epochTimestamp,
            ...$2945e13ce7899c45$export$d349f2f4b9260407(runtimeValues),
            ...$2945e13ce7899c45$var$platformTestObjectValues(testObjectConfig),
            duration
        ]);
    }
    recordBeforeMeasurementBeaconEvent(epochTimestamp, runtimeValues) {
        this._beforeMeasurementBeaconEvents.push([
            epochTimestamp,
            ...$2945e13ce7899c45$export$d349f2f4b9260407(runtimeValues)
        ]);
    }
    recordBeforeSessionConfigDownloadEvent(epochTimestamp, runtimeValues) {
        const result = [
            epochTimestamp,
            ...$2945e13ce7899c45$export$d349f2f4b9260407(runtimeValues)
        ];
        this._beforeSessionConfigDownloadEvents.push(result);
        return result;
    }
    recordBeforeTestObjectDownloadEvent(epochTimestamp, runtimeValues, testObjectConfig) {
        this._beforeTestObjectDownloadEvents.push([
            epochTimestamp,
            ...$2945e13ce7899c45$export$d349f2f4b9260407(runtimeValues),
            ...$2945e13ce7899c45$var$platformTestObjectValues(testObjectConfig)
        ]);
    }
    recordClientInitializedEvent(epochTimestamp) {
        if (!this._clientInitializationRecorded) {
            this._clientInitializationRecorded = true;
            // Geo isn't known when the event is first recorded. It will
            // be updated after receiving the initial session config response.
            const result = [
                epochTimestamp,
                "",
                "",
                "",
                null
            ];
            this._clientInitializedEvent = result;
            return result;
        }
        throw new Error("Only one call to recordClientInitializedEvent should be made");
    }
    recordMeasurementBeaconErrorEvent(epochTimestamp, runtimeValues, errorMessage) {
        this._measurementBeaconErrorEvents.push([
            epochTimestamp,
            ...$2945e13ce7899c45$export$d349f2f4b9260407(runtimeValues),
            errorMessage
        ]);
    }
    recordSessionConfigDownloadErrorEvent(epochTimestamp, runtimeValues, errorMessage) {
        this._sessionConfigDownloadErrorEvents.push([
            epochTimestamp,
            ...$2945e13ce7899c45$export$d349f2f4b9260407(runtimeValues),
            errorMessage
        ]);
    }
}
const $2945e13ce7899c45$export$d349f2f4b9260407 = (runtimeValues)=>{
    const asn = parseInt(runtimeValues.lastReadSessConfHeaderAsn || "", 10);
    const result = [
        runtimeValues.lastReadSessConfHeaderContinent || null,
        runtimeValues.lastReadSessConfHeaderCountry || null,
        runtimeValues.lastReadSessConfHeaderState || null,
        isNaN(asn) ? null : asn
    ];
    return result;
};
const $2945e13ce7899c45$var$platformTestObjectValues = (testObjectConfig)=>{
    const result = [
        testObjectConfig.dopplerPlatformID,
        testObjectConfig.testObjectSize
    ];
    return result;
};




const $94a5e1f64604da35$export$4fd6202243e1ddf1 = (s, p)=>new $94a5e1f64604da35$var$EndpointsImpl(s, p);
class $94a5e1f64604da35$var$EndpointsImpl {
    constructor(source, pageSettings){
        /* eslint-disable @typescript-eslint/dot-notation */ this._applicationEventsBase = pageSettings.applicationLoggingEndpoint || source["application_events_base"];
        this._dopplerEndpoints = {
            // Provide a default until the session config file includes this
            // endpoint.
            dopplerResourceTimingEndpoint: pageSettings.dopplerBeaconEndpoint || source["doppler"]["resource_timing"]
        };
        this._pulsarEndpointBase = source["pulsar"];
    /* eslint-enable @typescript-eslint/dot-notation */ }
    get applicationEventsBase() {
        return this._applicationEventsBase;
    }
    get dopplerEndpoints() {
        return this._dopplerEndpoints;
    }
    get pulsarEndpointBase() {
        return this._pulsarEndpointBase;
    }
}


const $7ac753553a5d764b$export$7a8c43c1c01d1116 = (s, p)=>new $7ac753553a5d764b$var$SiteOwnerSettingsImpl(s, p);
class $7ac753553a5d764b$var$SiteOwnerSettingsImpl {
    constructor(settingsSource, pageSettings){
        /* eslint-disable @typescript-eslint/dot-notation */ this._applicationEventsBeaconIntervalInMilliseconds = $7ac753553a5d764b$var$secondsToMilliseconds(settingsSource["a"], pageSettings.applicationEventsBeaconInterval);
        this._dnsClientInfoBaseHostname = settingsSource["dcibh"];
        this._dnsClientInfoSamplePercentage = settingsSource["dcisp"];
        this._maxInitialTestObjects = settingsSource["m"];
        this._measurementStartDelay = settingsSource["st"];
        this._sessionRefreshIntervalInMilliseconds = $7ac753553a5d764b$var$secondsToMilliseconds(settingsSource["c"], pageSettings.sessionRefreshInterval);
        this._schedulerRunIntervalInMilliseconds = $7ac753553a5d764b$var$secondsToMilliseconds(settingsSource["sc"], pageSettings.schedulerRunInterval);
        this._networksDisallowed = settingsSource["n"] || [];
    /* eslint-enable @typescript-eslint/dot-notation */ }
    get networksDisallowed() {
        return this._networksDisallowed;
    }
    get dnsClientInfoBaseHostname() {
        return this._dnsClientInfoBaseHostname;
    }
    get dnsClientInfoSamplePercentage() {
        return this._dnsClientInfoSamplePercentage;
    }
    get applicationEventsBeaconIntervalInMilliseconds() {
        return this._applicationEventsBeaconIntervalInMilliseconds;
    }
    get maxInitialTestObjects() {
        return this._maxInitialTestObjects;
    }
    get measurementStartDelay() {
        return this._measurementStartDelay;
    }
    get sessionRefreshIntervalInMilliseconds() {
        return this._sessionRefreshIntervalInMilliseconds;
    }
    get schedulerRunIntervalInMilliseconds() {
        return this._schedulerRunIntervalInMilliseconds;
    }
}
function $7ac753553a5d764b$var$secondsToMilliseconds(sessionConfigSetting, pageLevelSetting) {
    const setting = typeof pageLevelSetting === "number" ? pageLevelSetting : sessionConfigSetting;
    return setting * 1000;
}


const $2e5c778b7156265c$export$15c17d6bf58b724d = (s, p)=>new $2e5c778b7156265c$var$Config3Impl(s, p);
class $2e5c778b7156265c$var$Config3Impl {
    constructor(source, pageSettings){
        /* eslint-disable @typescript-eslint/dot-notation */ const settings = source["s"];
        this._siteOwnerSettings = (0, $7ac753553a5d764b$export$7a8c43c1c01d1116)(settings, pageSettings);
        /* eslint-enable @typescript-eslint/dot-notation */ this._clientEndpoints = (0, $94a5e1f64604da35$export$4fd6202243e1ddf1)({
            // There currently isn't a configuration flag to disable application
            // event reporting explictly. Setting application_events_base
            // to null works for the time being.
            // application_events_base: "https://doppler-client-events.vtg.paramount.tech",
            application_events_base: null,
            doppler: {
                resource_timing: "https://doppler-beacon.vtg.paramount.tech/log"
            },
            pulsar: "https://b.ns1p.net?v=1583182801"
        }, pageSettings);
    }
    get siteOwnerSettings() {
        return this._siteOwnerSettings;
    }
    get beaconEndpointInfo() {
        return this._clientEndpoints;
    }
}


/**
 * Provides a mechanism to invoke a list of promises one at a time.
 * This can used by a {@link PromiseSequenceFunc} instead of Promise.all
 * @param funcs An array of functions that take no arguments and return a
 * Promise of type T
 * @returns A single promise that resolves with an array of T
 */ function $c483c4df4d69e2ca$export$2e2bcd8739ae039(funcs) {
    return funcs.reduce((prom, func)=>{
        return prom.then((results)=>func().then((result)=>[
                    ...results,
                    result
                ]).catch(()=>Promise.resolve(results)));
    }, Promise.resolve([]));
}


function $d4057b2940f42917$export$d7cb46a4e2f04c4f(executables) {
    const makeTaskExecFunc = (task)=>()=>task.execute();
    return (0, $c483c4df4d69e2ca$export$2e2bcd8739ae039)(executables.map(makeTaskExecFunc)).then((testResults)=>{
        return {
            testResults: testResults
        };
    });
}


function $f59f63587931ef69$export$46b1f666ffe5849f(sessionConfigDelayInMilliseconds, sessionStartupFuncs) {
    return new Promise((resolve)=>{
        setTimeout(()=>{
            $f59f63587931ef69$export$b3571188c770cc5a(sessionStartupFuncs).then((result)=>resolve(result));
        }, sessionConfigDelayInMilliseconds);
    });
}
function $f59f63587931ef69$export$b3571188c770cc5a(sessionStartupFuncs) {
    return Promise.allSettled(sessionStartupFuncs.map((funcs)=>funcs.fetchSessionConfiguration())).then((settled)=>{
        const executables = [];
        settled.forEach((result, idx)=>{
            if (result.status === "fulfilled" && "value" in result) executables.push(...sessionStartupFuncs[idx].produceExecutables(result.value));
        });
        const process = (0, $d4057b2940f42917$export$d7cb46a4e2f04c4f);
        return process(executables);
    });
}


/**
 * Utility to resolve a Promise when the browsers ready state reaches "complete"
 */ function $0cc7a9e09fef792f$export$4d2a34b88f2238c1(getDocumentReadyState, addDocumentReadyStateChangeListener) {
    // If document is ready, resolve immediately
    if (getDocumentReadyState() === "complete") return Promise.resolve();
    // Otherwise, attach event listener to resolve when ready
    return new Promise((resolve)=>{
        addDocumentReadyStateChangeListener(()=>{
            if (getDocumentReadyState() === "complete") resolve();
        });
    });
}


function $6fc7c74a6511bbe3$export$2cd8252107eb640b(getDocumentReadyState, addDocumentReadyStateChangeListener, sessionConfigDelayInMilliseconds, sessionStartupFuncs) {
    return (0, $0cc7a9e09fef792f$export$4d2a34b88f2238c1)(getDocumentReadyState, addDocumentReadyStateChangeListener).then(()=>{
        if (sessionConfigDelayInMilliseconds > 0) return (0, $f59f63587931ef69$export$46b1f666ffe5849f)(sessionConfigDelayInMilliseconds, sessionStartupFuncs);
        return (0, $f59f63587931ef69$export$b3571188c770cc5a)(sessionStartupFuncs);
    });
}



const $1283aad01cd46992$export$682c179f50ab847d = "1.0.0";
function $1283aad01cd46992$export$2e2bcd8739ae039(testObjectURL, testObjectConfig, testResults, sessionMetadata, runtimeValues) {
    const { lastReadSessConfHeaderContinent: lastReadSessConfHeaderContinent, lastReadSessConfHeaderCountry: lastReadSessConfHeaderCountry, lastReadSessConfHeaderAsn: lastReadSessConfHeaderAsn, resolverIP: resolverIP, sessionStartTimestamp: sessionStartTimestamp, sessionUUID: sessionUUID } = runtimeValues;
    if (!sessionStartTimestamp) throw new Error("Session start timestamp not set");
    if (!sessionUUID) throw new Error("Session UUID not set");
    if (!lastReadSessConfHeaderContinent) throw new Error("Last read continent header missing");
    if (!lastReadSessConfHeaderCountry) throw new Error("Last read country header missing");
    if (!lastReadSessConfHeaderAsn) throw new Error("Last read ASN header missing");
    if (!testResults.error && !testResults.entry) throw new Error("Resource Timing entry missing");
    // Hover over any of the keys to see a human-friendly description.
    const result = {
        c: {
            v: sessionMetadata.clientVersion.join(".")
        },
        s: {
            s: sessionStartTimestamp.getTime(),
            i: sessionUUID,
            h: {
                con: lastReadSessConfHeaderContinent,
                cou: lastReadSessConfHeaderCountry,
                a: lastReadSessConfHeaderAsn
            },
            u: {
                c: "web",
                d: {},
                o: {},
                b: {}
            }
        },
        met: {},
        mea: {
            i: testObjectConfig.dopplerPlatformID,
            s: testResults.testSetupResult.calledAt.getTime(),
            u: testObjectURL,
            r: testResults.error ? testResults.timeout ? "timeout-abort" : "unknown-error" : "success",
            o: {
                s: testObjectConfig.testObjectSize,
                m: testObjectConfig.testObjectTimeout
            }
        }
    };
    testResults.cdnResponseHeaderValue && (result.mea.c = testResults.cdnResponseHeaderValue);
    testResults.cdnPOPIDHeaderValue && (result.mea.ph = testResults.cdnPOPIDHeaderValue);
    testResults.cdnPOPID && (result.mea.p = testResults.cdnPOPID);
    typeof testResults.status == "number" && (result.mea.st = testResults.status);
    const browserMetadata = sessionMetadata.browserMeta;
    const deviceMetadata = browserMetadata.device;
    deviceMetadata.type && (result.s.u.d.t = deviceMetadata.type);
    deviceMetadata.vendor && (result.s.u.d.v = deviceMetadata.vendor);
    deviceMetadata.model && (result.s.u.d.m = deviceMetadata.model);
    const osMetadata = browserMetadata.os;
    osMetadata.name && (result.s.u.o.n = osMetadata.name);
    osMetadata.version && (result.s.u.o.v = osMetadata.version);
    const browserBrowserMetadata = browserMetadata.browser;
    browserBrowserMetadata.name && (result.s.u.b.n = browserBrowserMetadata.name);
    browserBrowserMetadata.version && (result.s.u.b.v = browserBrowserMetadata.version);
    // Only override hdx flag if pertinent (server default is true).
    if (testObjectConfig.hdxEnabled !== testObjectConfig.hdxEnabledDefault) result.met.hdx = testObjectConfig.hdxEnabled;
    if (testResults.entry) {
        const entry = testResults.entry;
        const floor = (value)=>Math.floor(value);
        result.mea.re = {
            c: {
                e: floor(entry.connectEnd),
                s: floor(entry.connectStart),
                se: floor(entry.secureConnectionStart)
            },
            do: {
                e: floor(entry.domainLookupEnd),
                s: floor(entry.domainLookupStart)
            },
            du: floor(entry.duration),
            f: floor(entry.fetchStart),
            i: entry.initiatorType,
            n: entry.nextHopProtocol,
            red: {
                e: floor(entry.redirectEnd),
                s: floor(entry.redirectStart)
            },
            req: floor(entry.requestStart),
            res: {
                e: floor(entry.responseEnd),
                s: floor(entry.responseStart)
            },
            si: {},
            st: floor(entry.startTime)
        };
        if (typeof entry.decodedBodySize === "number") result.mea.re.si.d = entry.decodedBodySize;
        if (typeof entry.encodedBodySize === "number") result.mea.re.si.e = entry.encodedBodySize;
        if (typeof entry.transferSize === "number") result.mea.re.si.t = entry.transferSize;
    }
    if (resolverIP) result.s.r = resolverIP;
    return result;
}



var $413e5e0f63a1b600$export$2e2bcd8739ae039 = (length, newRandomNumber)=>{
    const DICTIONARY = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const DICTIONARY_LENGTH = DICTIONARY.length;
    const randomLetter = ()=>DICTIONARY.charAt(Math.floor(newRandomNumber((0, $f50e7fcb55f78359$export$d45b5a6626e2d799)) * DICTIONARY_LENGTH));
    return Array(length).fill(null).reduce((acc)=>acc + randomLetter(), "");
};


function $40f992e93e049856$export$2e2bcd8739ae039(baseURL, newRandomNumber) {
    const cacheBuster = `rnd=${(0, $413e5e0f63a1b600$export$2e2bcd8739ae039)(20, newRandomNumber)}`;
    return `${baseURL}?${cacheBuster}`;
}


class $5d65dfadff0b8bf3$export$4ea3ec9a6106f269 extends Error {
    constructor(urlBeingAdded, urlStillRegistered){
        super(`Callback not consumed (being added: ${urlBeingAdded},` + ` still registered: ${urlStillRegistered})`);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
class $5d65dfadff0b8bf3$export$102eec660531a5d8 extends Error {
    constructor(url, duration, maxWait){
        super(`Failed to find an entry for ${url} after ${duration}` + ` milliseconds (max wait ${maxWait})`);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
/**
 * A class to monitor the Resource Timing buffer for entries of interest.
 * Only one URL at a time is supported. Clients should be prepared to handle
 * any {@link RegisteredCallbackNotConsumedError} that may occur as a result.
 * We base this limitation on the idea that it's better avoid measuring
 * resources in parallel.
 */ class $5d65dfadff0b8bf3$var$PerformanceEntryManagerImpl {
    constructor(_dependencies){
        this._dependencies = _dependencies;
        this._observer = this._dependencies.newPerformanceObserver((entryList)=>{
            if (this._callbackBundle != undefined) {
                // Note that getEntriesBy... *can* produce multiple
                // records for the same URL. However, this would be
                // considered pathological input indicating a problem
                // with the way measurements are being taken. Therefore,
                // we tend to overlook that possibility.
                const entries = entryList.getEntriesByName(this._callbackBundle.url, "resource");
                if (entries.length) {
                    // We could validate the entry `name` property, but
                    // we're counting on getEntriesByName to do the right
                    // thing
                    this._callbackBundle.callback(entries[0]);
                    delete this._callbackBundle;
                }
            }
        });
    }
    /**
   * Set the URL that the consumer is interested in and a callback to be
   * executed when it is observed.
   * @param url The precise URL of interest.
   * @param callback A callback to be executed when the registered URL
   * is observed.
   */ registerCallback(url, callback) {
        if (this._callbackBundle) throw new $5d65dfadff0b8bf3$export$4ea3ec9a6106f269(url, this._callbackBundle.url);
        this._callbackBundle = {
            url: url,
            callback: callback,
            registeredAt: this._dependencies.newDate()
        };
        this._observer.observe({
            type: "resource",
            // Disregard entries buffered before the observer was created
            buffered: false
        });
    }
    /**
   * Clear the registered callback if it matches the given URL.
   * @param url
   */ unregisterCallback(url) {
        if (this._callbackBundle && this._callbackBundle.url === url) delete this._callbackBundle;
        this._observer.disconnect();
    }
}
const $5d65dfadff0b8bf3$export$86e6d657b62cd9f6 = (d)=>new $5d65dfadff0b8bf3$var$PerformanceEntryManagerImpl(d);
class $5d65dfadff0b8bf3$export$8702fa20b368e563 {
    constructor(_url, _newDate, _setTimeout, performanceEntryManager){
        this._url = _url;
        this._newDate = _newDate;
        this._setTimeout = _setTimeout;
        performanceEntryManager.registerCallback(_url, (entry)=>{
            this._entry = entry;
        });
    }
    async awaitEntry() {
        if (this._entry) return this._entry;
        const beganAt = this._newDate().getTime();
        let entry;
        const MAX_WAIT = 2000;
        let diff = MAX_WAIT;
        do {
            const result = await Promise.all([
                new Promise((resolve)=>{
                    resolve(this._entry);
                }),
                new Promise((resolve)=>{
                    this._setTimeout(resolve, 100);
                })
            ]);
            if (result[0]) {
                entry = result[0];
                break;
            }
            const newDate = this._newDate();
            diff = newDate.getTime() - beganAt;
        }while (!entry && diff < MAX_WAIT);
        if (entry) return entry;
        throw new $5d65dfadff0b8bf3$export$102eec660531a5d8(this._url, diff, MAX_WAIT);
    }
}



async function $69205322588134a8$export$e7aa7bc5c1b3cfb3(dependencies, url, fetchTimeoutInMilliseconds, requestHeaders, beforeTest, beforeBeacon, sendBeacon, afterTest, onError) {
    try {
        const entryAwaiter = new (0, $5d65dfadff0b8bf3$export$8702fa20b368e563)(url, dependencies.newDate, dependencies.setTimeout, dependencies.performanceEntryManager);
        const result = await beforeTest();
        const response = await $69205322588134a8$var$fetchObject(dependencies, url, fetchTimeoutInMilliseconds, requestHeaders, result);
        if (response) {
            const entry = await entryAwaiter.awaitEntry();
            if (entry) {
                result.entry = entry;
                // Give the caller an opportunity to adorn the result based
                // on the response and data gathered so far
                await beforeBeacon(result, response);
            }
        }
        await sendBeacon(result);
        afterTest(result);
    } catch (e) {
        // Swallow errors but provide caller with an opportunity to respond
        onError(e);
    }
    // Unregister the performance entry callback as late in the measurement
    // sequence as possible
    dependencies.performanceEntryManager.unregisterCallback(url);
}
async function $69205322588134a8$var$fetchObject(dependencies, url, fetchTimeoutInMilliseconds, requestHeaders, result) {
    const abortController = dependencies.newAbortController();
    const timeoutID = dependencies.setTimeout(()=>{
        // Record that a timeout took place
        result.timeout = true;
        // Force download to stop
        abortController.abort();
    }, fetchTimeoutInMilliseconds);
    const options = {
        method: "GET",
        // Explicitly prevent request from outliving the page
        keepalive: false,
        signal: abortController.signal
    };
    if (requestHeaders) options.headers = {
        ...requestHeaders
    };
    try {
        const response = await dependencies.fetch(url, options);
        result.status = response.status;
        await response.blob();
        dependencies.clearTimeout(timeoutID);
        return response;
    } catch (e) {
        // Let caller handle the error later
        result.error = e;
    }
}




const $2d6f60ca72098832$var$newOnErrorMessage = (dopplerPlatformID, e, at)=>`onError ${dopplerPlatformID} (${at.toISOString()}): ${e}`;
const $2d6f60ca72098832$var$maxTargetFrequencyChangedMessage = (from, to)=>`Max target frequency changed by beacon response from ${from} to ${to}`;
function $2d6f60ca72098832$export$2e2bcd8739ae039(deps, config, sessionMetadata) {
    let baseURL = config.testObjectURL;
    if (config.addRandomSubdomainToken) {
        const token = (0, $413e5e0f63a1b600$export$2e2bcd8739ae039)(20, deps.newRandomNumber).toLowerCase();
        baseURL = decodeURI(baseURL);
        baseURL = baseURL.replace("${token}", token);
    }
    const resourceURL = (0, $40f992e93e049856$export$2e2bcd8739ae039)(baseURL, deps.newRandomNumber);
    /**
   * Milliseconds elapsed since baseline timestamp
   */ let testObjectDownloadMonotonicStartTime;
    const result = {
        execute: ()=>(0, $69205322588134a8$export$e7aa7bc5c1b3cfb3)({
                clearTimeout: (timeoutID)=>deps.callClearTimeout((0, $f50e7fcb55f78359$export$77a83a88485fcb44), timeoutID),
                fetch: deps.callFetch,
                newAbortController: deps.newAbortController,
                newDate: ()=>deps.newDate((0, $f50e7fcb55f78359$export$77a83a88485fcb44)),
                performanceEntryManager: deps.performanceEntryManager,
                setTimeout: (fn, timeout)=>deps.callSetTimeout((0, $f50e7fcb55f78359$export$77a83a88485fcb44), fn, timeout)
            }, resourceURL, config.testObjectTimeout, ((c)=>{
                deps.outputToConsole((0, $f50e7fcb55f78359$export$afb6987cdf6e791e).debug, ()=>`POP ID detection header: ${c.popIDDetectionHeader}`);
                deps.outputToConsole((0, $f50e7fcb55f78359$export$afb6987cdf6e791e).debug, ()=>`POP ID detection request headers: ${JSON.stringify(c.popIDDetectionReqHeaders)}`);
                if (c.popIDDetectionHeader && c.popIDDetectionHeader.length > 0) {
                    if (c.popIDDetectionReqHeaders && Object.keys(c.popIDDetectionReqHeaders).length > 0) return c.popIDDetectionReqHeaders;
                }
                return null;
            })(config), // beforeTest
            beforeTest, // beforeBeacon provides an opportunity to do things like read response
            // headers and further tag the test result bundle.
            (testResult, response)=>{
                deps.applicationEvents.recordAfterTestObjectDownloadEvent(deps.newDate((0, $f50e7fcb55f78359$export$ea40ff6a6ead088b)).getTime(), deps.runtimeValues, config, Math.floor(deps.newMonotonicTimestamp((0, $f50e7fcb55f78359$export$ea40ff6a6ead088b)) - testObjectDownloadMonotonicStartTime));
                if (config.cdnResponseHeader) {
                    const cdnName = response.headers.get(config.cdnResponseHeader);
                    if (cdnName) testResult.cdnResponseHeaderValue = cdnName;
                }
                if (config.popIDDetectionHeader) {
                    const cdnPOPHeader = response.headers.get(config.popIDDetectionHeader);
                    if (cdnPOPHeader) {
                        testResult.cdnPOPIDHeaderValue = cdnPOPHeader;
                        if (config.popIDDetectionHeaderRegex) {
                            const regex = new RegExp(config.popIDDetectionHeaderRegex);
                            const result = regex.exec(cdnPOPHeader);
                            /* eslint-disable @typescript-eslint/dot-notation */ const popID = result && result.groups && result.groups["pop"];
                            /* eslint-enable @typescript-eslint/dot-notation */ if (typeof popID == "string" && popID.length) testResult.cdnPOPID = popID;
                        } else testResult.cdnPOPID = cdnPOPHeader;
                    }
                }
                return Promise.resolve();
            }, // sendBeacon
            async (testResult)=>{
                try {
                    await sendDopplerBeacon(resourceURL, testResult);
                    sendLegacyPulsarBeacon(testResult);
                } catch  {
                // Catching exceptions here helps to prevent beacon errors from
                // appearing in the browser console, but it also reduces visibility
                // for troubleshooting purposes. Consider sending these to the
                // application log.
                }
            }, // afterTest
            (testResult)=>{
                deps.measurementScheduler.scheduleNextMeasurement(config);
                deps.measurementScheduler.outputDiagnosticMessage();
                return Promise.resolve(testResult);
            }, // onError
            (e)=>{
                deps.outputToConsole((0, $f50e7fcb55f78359$export$afb6987cdf6e791e).debug, ()=>$2d6f60ca72098832$var$newOnErrorMessage(config.dopplerPlatformID, e, deps.newDate((0, $f50e7fcb55f78359$export$4f2e90eea19ce64))));
                if (e instanceof (0, $5d65dfadff0b8bf3$export$4ea3ec9a6106f269)) // This means another measurement is still underway
                deps.measurementScheduler.scheduleNextMeasurementSoon(config);
                else if (e instanceof (0, $5d65dfadff0b8bf3$export$102eec660531a5d8)) {
                    // Generally an issue with the Resource Timing buffer,
                    // mainly in Firefox.
                    // For browsers that shut down tracking further performance
                    // events until the buffer is cleared, now is an acceptable
                    // time to do that.
                    // Arbitrary number of errors to allow before clearing the
                    // buffer again
                    deps.performanceEntryAwaitTimeouts.add(1);
                    if (deps.performanceEntryAwaitTimeouts.countOfEvents > 5) {
                        deps.callClearResourceTimings();
                        deps.performanceEntryAwaitTimeouts.reset();
                    }
                    // Reschedule normally
                    deps.measurementScheduler.scheduleNextMeasurementSoon(config);
                }
            })
    };
    return result;
    async function sendDopplerBeacon(testObjectURL, testResult) {
        const beaconRequestMonotonicStartTime = deps.newMonotonicTimestamp((0, $f50e7fcb55f78359$export$2991cf5fa872fe45));
        deps.applicationEvents.recordBeforeMeasurementBeaconEvent(deps.newEpochTimestamp((0, $f50e7fcb55f78359$export$2991cf5fa872fe45)), deps.runtimeValues);
        const headers = {
            "doppler-payload-version": (0, $1283aad01cd46992$export$682c179f50ab847d),
            "content-type": "application/json"
        };
        const payload = (0, $1283aad01cd46992$export$2e2bcd8739ae039)(testObjectURL, config, testResult, sessionMetadata, deps.runtimeValues);
        const options = {
            method: "POST",
            // Explicitly allow request to outlive page similar to sendBeacon
            keepalive: true,
            headers: new Headers(headers),
            body: (0, $35ac4885fa0e8013$export$c564cdbbe6da493)(payload)
        };
        return deps.callFetch(config.endpointDoppler, options).then((resp)=>resp.json()).then((payload)=>{
            // Deem the beacon successful
            deps.applicationEvents.recordAfterMeasurementBeaconEvent(deps.newEpochTimestamp((0, $f50e7fcb55f78359$export$2991cf5fa872fe45)), deps.runtimeValues, Math.floor(deps.newMonotonicTimestamp((0, $f50e7fcb55f78359$export$2991cf5fa872fe45)) - beaconRequestMonotonicStartTime));
            const continent = payload.g.con;
            const country = payload.g.cou;
            const subdiv = payload.g.s;
            const asn = payload.g.a;
            if (continent) deps.runtimeValues.lastReadBeaconContinent = continent;
            if (country) deps.runtimeValues.lastReadBeaconCountry = country;
            if (subdiv) deps.runtimeValues.lastReadBeaconState = subdiv;
            if (asn) {
                deps.runtimeValues.lastReadBeaconAsn = asn;
                deps.runtimeValues.updateMeasurementsEnabledForNetwork(asn);
            }
            // Reschedule measurements if there's been a change to the max target frequency.
            if (typeof payload.m == "number" && payload.m > 0 && deps.maxTargetFrequency.value != payload.m) {
                const makeMessageFunc = (from, to)=>()=>$2d6f60ca72098832$var$maxTargetFrequencyChangedMessage(from, to);
                deps.outputToConsole((0, $f50e7fcb55f78359$export$afb6987cdf6e791e).debug, makeMessageFunc(deps.maxTargetFrequency.value, payload.m));
                deps.maxTargetFrequency.value = payload.m;
                deps.measurementScheduler.reschedule();
            } else if ((typeof payload.m != "number" || payload.m <= 0) && deps.maxTargetFrequency.value != 0) {
                deps.outputToConsole((0, $f50e7fcb55f78359$export$afb6987cdf6e791e).debug, ()=>$2d6f60ca72098832$var$maxTargetFrequencyChangedMessage(deps.maxTargetFrequency.value, 0));
                deps.maxTargetFrequency.value = 0;
                deps.measurementScheduler.reschedule();
            }
        }).catch((e)=>{
            if (e instanceof Error) deps.applicationEvents.recordMeasurementBeaconErrorEvent(deps.newEpochTimestamp((0, $f50e7fcb55f78359$export$2991cf5fa872fe45)), deps.runtimeValues, e.message);
        });
    }
    async function beforeTest() {
        if (deps.runtimeValues.measurementsEnabled) {
            if (config.coldStartDownloadEnabled) await doColdStartDownload();
            deps.applicationEvents.recordBeforeTestObjectDownloadEvent(deps.newEpochTimestamp((0, $f50e7fcb55f78359$export$ef4cf38734a1ac6a)), deps.runtimeValues, config);
            testObjectDownloadMonotonicStartTime = deps.newMonotonicTimestamp((0, $f50e7fcb55f78359$export$ef4cf38734a1ac6a));
            return Promise.resolve({
                testSetupResult: {
                    calledAt: deps.newDate((0, $f50e7fcb55f78359$export$ef4cf38734a1ac6a))
                },
                timeout: false
            });
        }
        return Promise.reject(new Error("beforeTest: Measurement blocked (measurements disabled)"));
        async function doColdStartDownload() {
            const coldStartDownloadURL = (0, $40f992e93e049856$export$2e2bcd8739ae039)(baseURL, deps.newRandomNumber);
            deps.outputToConsole((0, $f50e7fcb55f78359$export$afb6987cdf6e791e).debug, ()=>`Cold start download for ${config.dopplerPlatformID}` + ` (delay after: ${config.postColdStartDownloadDelayInSeconds}s,` + ` URL: ${coldStartDownloadURL})`);
            try {
                const response = await deps.callFetch(coldStartDownloadURL);
                if (response.status < 200 || response.status > 299) {
                    // Send an error report
                    await sendDopplerBeacon(coldStartDownloadURL, {
                        error: new Error("cold start download non-2xx status for platform ID" + `${config.dopplerPlatformID}: ${response.status}`),
                        testSetupResult: {
                            calledAt: deps.newDate((0, $f50e7fcb55f78359$export$b9bbcaf4a87a9d3a))
                        },
                        status: response.status,
                        timeout: false
                    });
                    deps.measurementScheduler.scheduleNextMeasurement(config);
                    deps.measurementScheduler.outputDiagnosticMessage();
                    return Promise.reject(new Error("cold start download failed (non-2xx response)"));
                }
                if (config.postColdStartDownloadDelayInSeconds > 0) await sleep(config.postColdStartDownloadDelayInSeconds * 1000);
            } catch  {
                // Send an error report
                await sendDopplerBeacon(coldStartDownloadURL, {
                    error: new Error(`cold start download failed for platform ID ${config.dopplerPlatformID}`),
                    testSetupResult: {
                        calledAt: deps.newDate((0, $f50e7fcb55f78359$export$b9bbcaf4a87a9d3a))
                    },
                    timeout: false
                });
                deps.measurementScheduler.scheduleNextMeasurement(config);
                deps.measurementScheduler.outputDiagnosticMessage();
                return Promise.reject(new Error("cold start download failed (error)"));
            }
            async function sleep(delayInMilliseconds) {
                return new Promise((resolve)=>{
                    deps.callSetTimeout((0, $f50e7fcb55f78359$export$b9bbcaf4a87a9d3a), ()=>resolve(null), delayInMilliseconds);
                });
            }
        }
    }
    function sendLegacyPulsarBeacon(testResult) {
        if (config.includePulsar) {
            if (testResult.error || testResult.status !== 200) {
                const intervalInMilliseconds = Math.floor(deps.newMonotonicTimestamp((0, $f50e7fcb55f78359$export$c5f3025e56ccffdd)) - testObjectDownloadMonotonicStartTime);
                // Not sure if NS1 would rather have 650 here or the real
                // non-200 status
                deps.callSendBeacon((0, $f50e7fcb55f78359$export$c5f3025e56ccffdd), makeBeaconURL(650, intervalInMilliseconds));
            } else {
                const entry = testResult.entry;
                deps.callSendBeacon((0, $f50e7fcb55f78359$export$c5f3025e56ccffdd), makeBeaconURL(testResult.status, // TTLB
                Math.floor(entry.responseEnd - entry.requestStart)));
            }
        }
        function makeBeaconURL(httpStatus, value) {
            const randomString = Math.floor(deps.newRandomNumber((0, $f50e7fcb55f78359$export$c5f3025e56ccffdd)) * 4294967296);
            // eslint-disable-next-line max-len
            return `${config.endpointPulsarBase}&a=${config.pulsarAppID}&x=${randomString}&r=${config.pulsarJobID}:x|${httpStatus}|${value}`;
        }
    }
}


const $87aa058656beb7b3$export$849308e0bf4cf1f6 = (s, d, p)=>new $87aa058656beb7b3$var$PlatformTestObjectImpl(s, d, p);
class $87aa058656beb7b3$var$PlatformTestObjectImpl {
    constructor(source, endpointDoppler, endpointPulsarBase){
        /* eslint-disable @typescript-eslint/dot-notation */ const addRandomSubdomainToken = source["a"];
        const dopplerPlatformID = source["i"];
        const url = source["u"];
        const size = source["s"];
        const timeoutInSeconds = source["t"];
        const pulsarAppID = source["pa"];
        const pulsarJobID = source["pj"];
        const targetFrequency = source["f"];
        const sendToDoppler = source["d"];
        const sendToPulsar = source["p"] && !!pulsarAppID && !!pulsarJobID;
        const coldStartDownloadEnabled = source["c"];
        const postColdStartDownloadDelayInSeconds = source["cd"];
        const usedForDecisioning = source["us"];
        const popIDDetectionHeader = source["po"] && source["po"]["h"];
        const popIDDetectionHeaderRegex = source["po"] && source["po"]["r"];
        const popIDDetectionReqHeaders = source["po"] && source["po"]["rh"];
        /* eslint-enable @typescript-eslint/dot-notation */ this._addRandomSubdomainToken = addRandomSubdomainToken;
        this._cdnResponseHeader = "x-cdn";
        this._dopplerPlatformID = dopplerPlatformID;
        if (pulsarAppID) this._pulsarAppID = pulsarAppID;
        if (pulsarJobID) this._pulsarJobID = pulsarJobID;
        this._endpointDoppler = endpointDoppler;
        this._endpointPulsarBase = endpointPulsarBase;
        this._hdxEnabled = usedForDecisioning;
        this._hdxEnabledDefault = true;
        this._includePulsar = sendToPulsar;
        this._includeDoppler = sendToDoppler;
        this._targetFrequency = targetFrequency;
        this._testObjectURL = url;
        this._testObjectSize = size;
        // this._testObjectTimeout is in milliseconds
        this._testObjectTimeout = 1000 * timeoutInSeconds;
        this._popIDDetectionHeader = popIDDetectionHeader;
        this._popIDDetectionHeaderRegex = popIDDetectionHeaderRegex;
        this._popIDDetectionReqHeaders = popIDDetectionReqHeaders;
        this._coldStartDownloadEnabled = coldStartDownloadEnabled;
        this._postColdStartDownloadDelayInSeconds = postColdStartDownloadDelayInSeconds;
    }
    get addRandomSubdomainToken() {
        return this._addRandomSubdomainToken;
    }
    get cdnResponseHeader() {
        return this._cdnResponseHeader;
    }
    get dopplerPlatformID() {
        return this._dopplerPlatformID;
    }
    get endpointDoppler() {
        return this._endpointDoppler;
    }
    get endpointPulsarBase() {
        return this._endpointPulsarBase;
    }
    get hdxEnabled() {
        return this._hdxEnabled;
    }
    get hdxEnabledDefault() {
        return this._hdxEnabledDefault;
    }
    get includeDoppler() {
        return this._includeDoppler;
    }
    get includePulsar() {
        return this._includePulsar;
    }
    get coldStartDownloadEnabled() {
        return !!this._coldStartDownloadEnabled;
    }
    get postColdStartDownloadDelayInSeconds() {
        if (typeof this._postColdStartDownloadDelayInSeconds == "number") return this._postColdStartDownloadDelayInSeconds;
        return 4;
    }
    get pulsarAppID() {
        return this._pulsarAppID;
    }
    get pulsarJobID() {
        return this._pulsarJobID;
    }
    get targetFrequency() {
        return this._targetFrequency;
    }
    get testObjectSize() {
        switch(this._testObjectSize){
            case 1555000:
                return 1555;
            case 43:
                return 43;
        }
        return Math.floor(this._testObjectSize / 1000);
    }
    get testObjectTimeout() {
        return this._testObjectTimeout;
    }
    get testObjectURL() {
        return this._testObjectURL;
    }
    get popIDDetectionHeader() {
        return this._popIDDetectionHeader;
    }
    get popIDDetectionHeaderRegex() {
        return this._popIDDetectionHeaderRegex;
    }
    get popIDDetectionReqHeaders() {
        return this._popIDDetectionReqHeaders;
    }
}



function $ae7c7375d89d8e89$export$2e2bcd8739ae039(population, count, getRandom) {
    const copyOfInput = [
        ...population
    ];
    // Fisher-Yates shuffle
    for(let i = copyOfInput.length - 1; i > 0; i--){
        const j = Math.floor(getRandom() * (i + 1));
        const temp = copyOfInput[i];
        copyOfInput[i] = copyOfInput[j];
        copyOfInput[j] = temp;
    }
    return copyOfInput.slice(0, count);
}
function $ae7c7375d89d8e89$export$2755796bb0e314c5(population, count, newRandomNumber, getWeightingFactorFn, maxExpectedWeightingFactor) {
    const copyOfInput = population.flatMap((obj)=>{
        // Cap granularity to avoid using too much memory
        const weightingFactor = Math.min(getWeightingFactorFn(obj), maxExpectedWeightingFactor);
        return Array(weightingFactor).fill(obj);
    });
    const result = [];
    let i = count;
    while(i-- && copyOfInput.length){
        // Select a random item from the weighted array
        const obj = copyOfInput[Math.floor(newRandomNumber((0, $f50e7fcb55f78359$export$f7450c06f6b28788)) * copyOfInput.length)];
        result.push(obj);
        // Remove the item so it can't be selected again
        copyOfInput.reduceRight((prev, curr, idx)=>{
            if (curr === obj) prev.splice(idx, 1);
            return prev;
        }, copyOfInput);
    }
    return result;
}


const $1aeb8a75f3c77a2e$var$buildPopulation = (objectsSource, endpointDoppler, endpointPulsarBase)=>{
    const newTestObject = (sourceObj)=>{
        return (0, $87aa058656beb7b3$export$849308e0bf4cf1f6)(sourceObj, endpointDoppler, endpointPulsarBase);
    };
    return objectsSource.map((value)=>newTestObject(value));
};
const $1aeb8a75f3c77a2e$export$a5cd94ad52fb3a38 = (dependencies, sessionMetadata, pageSettings, objectsSource, sessionConfig)=>{
    const population = $1aeb8a75f3c77a2e$var$buildPopulation(objectsSource, sessionConfig.beaconEndpointInfo.dopplerEndpoints.dopplerResourceTimingEndpoint, sessionConfig.beaconEndpointInfo.pulsarEndpointBase);
    // Draw a weighted random sample for immediate measurement
    const sampleToMeasureImmediately = (0, $ae7c7375d89d8e89$export$2755796bb0e314c5)(population, sessionConfig.siteOwnerSettings.maxInitialTestObjects, dependencies.newRandomNumber, // Use the target frequency as the "weighting factor". Since this could
    // be a decimal number less than 1, be sure to round up
    (config)=>Math.ceil(config.targetFrequency), // Expect target frequencies less than 1 per minute
    60);
    dependencies.measurementScheduler.initializePopulation(population, sessionMetadata, sampleToMeasureImmediately);
    // Convert the result to a set of "executables" for OpenInsights to process
    return sampleToMeasureImmediately.map((config)=>(0, $2d6f60ca72098832$export$2e2bcd8739ae039)({
            applicationEvents: dependencies.applicationEvents,
            callClearTimeout: dependencies.callClearTimeout,
            callSendBeacon: dependencies.callSendBeacon,
            callSetTimeout: dependencies.callSetTimeout,
            callClearResourceTimings: dependencies.callClearResourceTimings,
            callFetch: dependencies.callFetch,
            maxTargetFrequency: dependencies.maxTargetFrequency,
            measurementScheduler: dependencies.measurementScheduler,
            newAbortController: dependencies.newAbortController,
            newDate: dependencies.newDate,
            newEpochTimestamp: dependencies.newEpochTimestamp,
            newMonotonicTimestamp: dependencies.newMonotonicTimestamp,
            newRandomNumber: dependencies.newRandomNumber,
            outputToConsole: dependencies.outputToConsole,
            performanceEntryAwaitTimeouts: dependencies.performanceEntryAwaitTimeouts,
            performanceEntryManager: dependencies.performanceEntryManager,
            runtimeValues: dependencies.runtimeValues
        }, config, sessionMetadata));
};
const $1aeb8a75f3c77a2e$export$eebcc1afecb95ea3 = (measurementScheduler, sessionMetadata, objectsSource, endpointDoppler, endpointPulsarBase)=>measurementScheduler.updatePopulation($1aeb8a75f3c77a2e$var$buildPopulation(objectsSource, endpointDoppler, endpointPulsarBase), sessionMetadata);



function $f30c0ea409952391$export$2e2bcd8739ae039(dependencies, source, pageSettings) {
    const sessionUUID = dependencies.runtimeValues.sessionUUID;
    if (!sessionUUID) return Promise.reject("Session UUID not set");
    /* eslint-disable @typescript-eslint/dot-notation */ const baseHostname = source["s"]["dcibh"];
    let samplePercentage = source["s"]["dcisp"];
    /* eslint-enable @typescript-eslint/dot-notation */ if (typeof pageSettings.dnsClientInfoSamplePct === "number" && pageSettings.dnsClientInfoSamplePct >= 0 && pageSettings.dnsClientInfoSamplePct <= 1) samplePercentage = pageSettings.dnsClientInfoSamplePct;
    const url = `https://${sessionUUID}.${baseHostname}/clientinfo`;
    // samplePercentage is in the range [0,1].
    return dependencies.newRandomNumber((0, $f50e7fcb55f78359$export$245eccbcbac9dcf8)) < samplePercentage ? dependencies.callFetch(url, {
        // Add a timeout to the DNS Client Info request. This should allow
        // measurements to continue, only without the resolver IP.
        signal: dependencies.callAbortSignalTimeout((0, $f50e7fcb55f78359$export$245eccbcbac9dcf8), 5000)
    }).then((response)=>response.json()).then((responseData)=>{
        /* eslint-disable @typescript-eslint/dot-notation */ const resolverIP = responseData["resolver_ip"];
        /* eslint-enable @typescript-eslint/dot-notation */ dependencies.runtimeValues.resolverIP = resolverIP;
        return source;
    }).catch((_e)=>{
        // Consider writing to the application event log.
        return source;
    }) : Promise.resolve(source);
}


const $d68b1039d176e4d9$var$newAppEventLoggingEndpointMessage = (appEventLoggingEndpoint)=>`Application event logging endpoint: ${appEventLoggingEndpoint}`;
const $d68b1039d176e4d9$export$889ea624f2cb2c57 = (dependencies, clientInitInfo)=>{
    // Start engines
    const pageSettings = clientInitInfo.pageSettings;
    $d68b1039d176e4d9$var$downloadSessionConfiguration(dependencies, clientInitInfo, onInitialSessionConfigSourceReceived).then((sessionConfigInstance)=>{
        if (sessionConfigInstance) {
            const runtimeValues = dependencies.runtimeValues;
            $d68b1039d176e4d9$var$scheduleSessionConfigurationRefreshInterval(dependencies, runtimeValues, sessionConfigInstance, clientInitInfo);
            $d68b1039d176e4d9$var$scheduleApplicationEventsBeaconInterval(dependencies, runtimeValues, sessionConfigInstance);
            $d68b1039d176e4d9$var$scheduleMeasurementSchedulerRunInterval(dependencies, runtimeValues, sessionConfigInstance);
        }
    });
    function onInitialSessionConfigSourceReceived(asn, continentCode, countryCode, source) {
        const newSessionConfig = (0, $2e5c778b7156265c$export$15c17d6bf58b724d)(source, pageSettings);
        dependencies.runtimeValues.sessionConfigLastUpdatedAt = dependencies.newDate((0, $f50e7fcb55f78359$export$4626418fce14be65));
        dependencies.applicationEvents.applicationEventLoggingEndpointBase = newSessionConfig.beaconEndpointInfo.applicationEventsBase;
        dependencies.outputToConsole((0, $f50e7fcb55f78359$export$afb6987cdf6e791e).debug, ()=>$d68b1039d176e4d9$var$newAppEventLoggingEndpointMessage(dependencies.applicationEvents.applicationEventLoggingEndpointBase));
        dependencies.runtimeValues.disallowedNetworks = newSessionConfig.siteOwnerSettings.networksDisallowed;
        dependencies.runtimeValues.updateMeasurementsEnabledForNetwork(asn);
        // Skip the opening session unless measurements are enabled
        if (dependencies.runtimeValues.measurementsEnabled) {
            const startDelay = typeof pageSettings.measurementStartDelay === "number" ? pageSettings.measurementStartDelay : newSessionConfig.siteOwnerSettings.measurementStartDelay;
            // Schedule the opening session
            dependencies.callSetTimeout((0, $f50e7fcb55f78359$export$4626418fce14be65), ()=>{
                (0, $6fc7c74a6511bbe3$export$2cd8252107eb640b)(dependencies.getDocumentReadyState, dependencies.addDocumentReadyStateChangeListener, 0, [
                    {
                        fetchSessionConfiguration: ()=>Promise.resolve(newSessionConfig),
                        produceExecutables: produceExecutables
                    }
                ]).then(()=>// Insert a slight delay in order to let the last beacon
                    // complete. In most cases this avoids sending another
                    // application event beacon on the interval.
                    dependencies.callSetTimeout((0, $f50e7fcb55f78359$export$f03e2bcfeea63600), ()=>dependencies.applicationEvents.beacon(), 1000));
            }, startDelay * 1000);
        } else dependencies.outputToConsole((0, $f50e7fcb55f78359$export$afb6987cdf6e791e).info, ()=>"Doppler measurements disabled (initial session config)");
        return newSessionConfig;
        function produceExecutables(sessionConfigInstance) {
            return (0, $1aeb8a75f3c77a2e$export$a5cd94ad52fb3a38)({
                applicationEvents: dependencies.applicationEvents,
                callClearTimeout: dependencies.callClearTimeout,
                callSendBeacon: dependencies.callSendBeacon,
                callSetTimeout: dependencies.callSetTimeout,
                callClearResourceTimings: dependencies.callClearResourceTimings,
                callFetch: dependencies.callFetch,
                maxTargetFrequency: dependencies.maxTargetFrequency,
                measurementScheduler: dependencies.measurementScheduler,
                newAbortController: dependencies.newAbortController,
                newDate: dependencies.newDate,
                newEpochTimestamp: dependencies.newEpochTimestamp,
                newMonotonicTimestamp: dependencies.newMonotonicTimestamp,
                newRandomNumber: dependencies.newRandomNumber,
                outputToConsole: dependencies.outputToConsole,
                performanceEntryAwaitTimeouts: dependencies.performanceEntryAwaitTimeouts,
                performanceEntryManager: dependencies.performanceEntryManager,
                runtimeValues: dependencies.runtimeValues
            }, clientInitInfo.sessionMetadata, pageSettings, /* eslint-disable @typescript-eslint/dot-notation */ source["o"], /* eslint-enable @typescript-eslint/dot-notation */ sessionConfigInstance);
        }
    }
};
const $d68b1039d176e4d9$var$newApplicationEventsBeaconIntervalMessage = (interval)=>`Application events beacon interval ${interval} ms`;
function $d68b1039d176e4d9$var$scheduleApplicationEventsBeaconInterval(dependencies, runtimeValues, sessionConfigInstance) {
    const interval = sessionConfigInstance.siteOwnerSettings.applicationEventsBeaconIntervalInMilliseconds;
    if (!isNaN(interval)) {
        if (interval > 0) {
            dependencies.outputToConsole((0, $f50e7fcb55f78359$export$afb6987cdf6e791e).debug, ()=>$d68b1039d176e4d9$var$newApplicationEventsBeaconIntervalMessage(interval));
            runtimeValues.applicationEventsBeaconIntervalInMilliseconds = interval;
            runtimeValues.applicationEventsBeaconIntervalID = dependencies.callSetInterval((0, $f50e7fcb55f78359$export$12bd9e3412a47319), ()=>dependencies.applicationEvents.beacon(), interval);
        } else {
            runtimeValues.applicationEventsBeaconIntervalInMilliseconds = 0;
            dependencies.outputToConsole((0, $f50e7fcb55f78359$export$afb6987cdf6e791e).warn, ()=>"Invalid page setting: application events beacon interval");
        }
    }
}
const $d68b1039d176e4d9$var$newSessionRefreshIntervalMessage = (interval)=>`Session refresh interval ${interval} ms`;
function $d68b1039d176e4d9$var$scheduleSessionConfigurationRefreshInterval(dependencies, runtimeValues, sessionConfigInstance, clientInitInfo) {
    const interval = sessionConfigInstance.siteOwnerSettings.sessionRefreshIntervalInMilliseconds;
    if (!isNaN(interval)) {
        if (interval > 0) {
            dependencies.outputToConsole((0, $f50e7fcb55f78359$export$afb6987cdf6e791e).debug, ()=>$d68b1039d176e4d9$var$newSessionRefreshIntervalMessage(interval));
            runtimeValues.sessionRefreshDelayInMilliseconds = interval;
            runtimeValues.sessionConfigRefreshIntervalID = dependencies.callSetInterval((0, $f50e7fcb55f78359$export$cfed8745ff76e923), ()=>$d68b1039d176e4d9$var$downloadSessionConfiguration(dependencies, clientInitInfo, $d68b1039d176e4d9$var$newSubsequentSessionConfigSourceReceivedFunc(dependencies, clientInitInfo)).then($d68b1039d176e4d9$var$newProcessNewSessionConfigurationFunc(dependencies, clientInitInfo)), interval);
        } else {
            runtimeValues.sessionRefreshDelayInMilliseconds = 0;
            dependencies.outputToConsole((0, $f50e7fcb55f78359$export$afb6987cdf6e791e).warn, ()=>"Invalid page setting: session config refresh interval");
        }
    }
}
const $d68b1039d176e4d9$var$newSchedulerRunIntervalMessage = (interval)=>`Scheduler run interval ${interval} ms`;
function $d68b1039d176e4d9$var$scheduleMeasurementSchedulerRunInterval(dependencies, runtimeValues, sessionConfigInstance) {
    const interval = sessionConfigInstance.siteOwnerSettings.schedulerRunIntervalInMilliseconds;
    if (!isNaN(interval)) {
        if (interval > 0) {
            dependencies.outputToConsole((0, $f50e7fcb55f78359$export$afb6987cdf6e791e).debug, ()=>$d68b1039d176e4d9$var$newSchedulerRunIntervalMessage(interval));
            runtimeValues.schedulerRunIntervalInMilliseconds = interval;
            runtimeValues.schedulerRunIntervalID = dependencies.callSetInterval((0, $f50e7fcb55f78359$export$c2fb045080e086af), ()=>dependencies.measurementScheduler.run(), interval);
        } else {
            runtimeValues.schedulerRunIntervalInMilliseconds = 0;
            dependencies.outputToConsole((0, $f50e7fcb55f78359$export$afb6987cdf6e791e).warn, ()=>"Invalid page setting: scheduler run interval");
        }
    }
}
const $d68b1039d176e4d9$var$newDownloadingSessionConfigurationMessage = (newDate)=>`Downloading new session configuration (${newDate((0, $f50e7fcb55f78359$export$93cdbe1e4a1d4654))})`;
async function $d68b1039d176e4d9$var$downloadSessionConfiguration(dependencies, clientInitInfo, handleSessionConfigSourceReceived) {
    dependencies.outputToConsole((0, $f50e7fcb55f78359$export$afb6987cdf6e791e).info, ()=>$d68b1039d176e4d9$var$newDownloadingSessionConfigurationMessage(dependencies.newDate));
    const sessionConfigMonotonicStartTime = dependencies.newMonotonicTimestamp((0, $f50e7fcb55f78359$export$55b9edfb793fa6af));
    const beforeDownloadEvent = dependencies.applicationEvents.recordBeforeSessionConfigDownloadEvent(dependencies.newEpochTimestamp((0, $f50e7fcb55f78359$export$55b9edfb793fa6af)), dependencies.runtimeValues);
    dependencies.runtimeValues.sessionStartTimestamp = dependencies.newDate((0, $f50e7fcb55f78359$export$55b9edfb793fa6af));
    dependencies.runtimeValues.sessionUUID = dependencies.newUUIDv4();
    dependencies.runtimeValues.resolverIP = undefined;
    // Also need to implement completed and error event reporting
    return dependencies.callFetch(clientInitInfo.sessionConfigURL).then((response)=>response.json()).then((source)=>(0, $f30c0ea409952391$export$2e2bcd8739ae039)(dependencies, source, clientInitInfo.pageSettings)).then((source)=>{
        // Freshen session config metadata
        /* eslint-disable @typescript-eslint/dot-notation */ const asn = source["g"]["a"];
        const continentCode = source["g"]["con"];
        const countryCode = source["g"]["c"];
        const stateCode = source["g"]["s"];
        /* eslint-enable @typescript-eslint/dot-notation */ dependencies.runtimeValues.lastReadSessConfHeaderContinent = continentCode;
        dependencies.runtimeValues.lastReadSessConfHeaderCountry = countryCode;
        dependencies.runtimeValues.lastReadSessConfHeaderState = stateCode;
        dependencies.runtimeValues.lastReadSessConfHeaderAsn = asn.toString(10);
        dependencies.applicationEvents.recordAfterSessionConfigDownloadEvent(dependencies.newEpochTimestamp((0, $f50e7fcb55f78359$export$55b9edfb793fa6af)), dependencies.runtimeValues, Math.floor(dependencies.newMonotonicTimestamp((0, $f50e7fcb55f78359$export$55b9edfb793fa6af)) - sessionConfigMonotonicStartTime));
        // Update geo for the early application events that wouldn't
        // have it yet.
        const geoHeaders = (0, $2945e13ce7899c45$export$d349f2f4b9260407)(dependencies.runtimeValues);
        beforeDownloadEvent.splice(1, 4, ...geoHeaders);
        clientInitInfo.clientInitializationEvent.splice(1, 4, ...geoHeaders);
        return handleSessionConfigSourceReceived(asn, continentCode, countryCode, source);
    }).catch((e)=>{
        // Prevent red stuff in the browser related to session config,
        // but anything here is probably worth immediate application
        // event logging
        if (e instanceof Error) dependencies.applicationEvents.recordSessionConfigDownloadErrorEvent(dependencies.newEpochTimestamp((0, $f50e7fcb55f78359$export$55b9edfb793fa6af)), dependencies.runtimeValues, e.message);
        dependencies.applicationEvents.beacon();
    });
}
function $d68b1039d176e4d9$var$newSubsequentSessionConfigSourceReceivedFunc(dependencies, clientInitInfo) {
    return (asn, continentCode, countryCode, source)=>{
        const newSessionConfig = (0, $2e5c778b7156265c$export$15c17d6bf58b724d)(source, clientInitInfo.pageSettings);
        dependencies.runtimeValues.sessionConfigLastUpdatedAt = dependencies.newDate((0, $f50e7fcb55f78359$export$259f8d0856621cd));
        dependencies.runtimeValues.disallowedNetworks = newSessionConfig.siteOwnerSettings.networksDisallowed;
        dependencies.runtimeValues.updateMeasurementsEnabledForNetwork(asn);
        if (!dependencies.runtimeValues.measurementsEnabled) dependencies.outputToConsole((0, $f50e7fcb55f78359$export$afb6987cdf6e791e).info, ()=>"Doppler measurements disabled (subsequent session config)");
        (0, $1aeb8a75f3c77a2e$export$eebcc1afecb95ea3)(dependencies.measurementScheduler, clientInitInfo.sessionMetadata, /* eslint-disable @typescript-eslint/dot-notation */ source["o"], /* eslint-enable @typescript-eslint/dot-notation */ newSessionConfig.beaconEndpointInfo.dopplerEndpoints.dopplerResourceTimingEndpoint, newSessionConfig.beaconEndpointInfo.pulsarEndpointBase);
        return newSessionConfig;
    };
}
const $d68b1039d176e4d9$var$newApplicationEventLoggingEndpointChangedMessage = (from, to)=>`Application event logging endpoint changed from ${from} to ${to}`;
const $d68b1039d176e4d9$var$newApplicationEventLoggingIntervalChangedMessage = (from, to)=>`Application events beacon interval changed from ${from} to ${to} milliseconds`;
const $d68b1039d176e4d9$var$newSessionRefreshIntervalChangedMessage = (from, to)=>`Session refresh interval changed from ${from} to ${to} milliseconds`;
const $d68b1039d176e4d9$var$newSchedulerRunIntervalChangedMessage = (from, to)=>`Scheduler run interval changed from ${from} to ${to} milliseconds`;
function $d68b1039d176e4d9$var$newProcessNewSessionConfigurationFunc(dependencies, clientInitInfo) {
    return (newSessionConfigInstance)=>{
        if (newSessionConfigInstance) {
            // Process any updates to the running session
            const runtimeValues = dependencies.runtimeValues;
            // Application event logging endpoint
            if (newSessionConfigInstance.beaconEndpointInfo.applicationEventsBase !== dependencies.applicationEvents.applicationEventLoggingEndpointBase) {
                dependencies.outputToConsole((0, $f50e7fcb55f78359$export$afb6987cdf6e791e).info, ()=>$d68b1039d176e4d9$var$newApplicationEventLoggingEndpointChangedMessage(dependencies.applicationEvents.applicationEventLoggingEndpointBase, newSessionConfigInstance.beaconEndpointInfo.applicationEventsBase));
                dependencies.applicationEvents.applicationEventLoggingEndpointBase = newSessionConfigInstance.beaconEndpointInfo.applicationEventsBase;
            }
            // Application events beacon interval
            if (newSessionConfigInstance.siteOwnerSettings.applicationEventsBeaconIntervalInMilliseconds !== runtimeValues.applicationEventsBeaconIntervalInMilliseconds) {
                dependencies.outputToConsole((0, $f50e7fcb55f78359$export$afb6987cdf6e791e).debug, ()=>$d68b1039d176e4d9$var$newApplicationEventLoggingIntervalChangedMessage(runtimeValues.applicationEventsBeaconIntervalInMilliseconds, newSessionConfigInstance.siteOwnerSettings.applicationEventsBeaconIntervalInMilliseconds));
                const intervalID = runtimeValues.applicationEventsBeaconIntervalID;
                if (typeof intervalID === "number") dependencies.callClearInterval((0, $f50e7fcb55f78359$export$12bd9e3412a47319), intervalID);
                $d68b1039d176e4d9$var$scheduleApplicationEventsBeaconInterval(dependencies, runtimeValues, newSessionConfigInstance);
            }
            // Session refresh interval
            if (newSessionConfigInstance.siteOwnerSettings.sessionRefreshIntervalInMilliseconds !== runtimeValues.sessionRefreshDelayInMilliseconds) {
                dependencies.outputToConsole((0, $f50e7fcb55f78359$export$afb6987cdf6e791e).debug, ()=>$d68b1039d176e4d9$var$newSessionRefreshIntervalChangedMessage(runtimeValues.sessionRefreshDelayInMilliseconds, newSessionConfigInstance.siteOwnerSettings.sessionRefreshIntervalInMilliseconds));
                const intervalID = runtimeValues.sessionConfigRefreshIntervalID;
                if (typeof intervalID === "number") dependencies.callClearInterval((0, $f50e7fcb55f78359$export$cfed8745ff76e923), intervalID);
                $d68b1039d176e4d9$var$scheduleSessionConfigurationRefreshInterval(dependencies, runtimeValues, newSessionConfigInstance, clientInitInfo);
            }
            // Scheduler run interval
            if (newSessionConfigInstance.siteOwnerSettings.schedulerRunIntervalInMilliseconds !== runtimeValues.schedulerRunIntervalInMilliseconds) {
                dependencies.outputToConsole((0, $f50e7fcb55f78359$export$afb6987cdf6e791e).debug, ()=>$d68b1039d176e4d9$var$newSchedulerRunIntervalChangedMessage(runtimeValues.schedulerRunIntervalInMilliseconds, newSessionConfigInstance.siteOwnerSettings.schedulerRunIntervalInMilliseconds));
                const intervalID = runtimeValues.schedulerRunIntervalID;
                if (typeof intervalID === "number") dependencies.callClearInterval((0, $f50e7fcb55f78359$export$c2fb045080e086af), intervalID);
                $d68b1039d176e4d9$var$scheduleMeasurementSchedulerRunInterval(dependencies, runtimeValues, newSessionConfigInstance);
            }
        }
    };
}


const $92e2aa6e01d15e04$var$version = "4.6.0";
var $92e2aa6e01d15e04$export$2e2bcd8739ae039 = $92e2aa6e01d15e04$var$version;


function $59daa7000386d092$export$d9616f691092113d(defaultValueInMilliseconds, pageSettings) {
    return typeof pageSettings.sessionConfigDelay === "number" ? pageSettings.sessionConfigDelay : defaultValueInMilliseconds;
}
function $59daa7000386d092$export$d0181195b6bd7eda(pageSettings) {
    const sessionConfigOrigin = pageSettings.sessionConfigOrigin ? pageSettings.sessionConfigOrigin : "https://doppler-config.vtg.paramount.tech";
    const qs = [
        `clientversion=${(0, $92e2aa6e01d15e04$export$2e2bcd8739ae039)}`
    ];
    if (pageSettings.rumConfigCountryOverride) qs.push(`c=${pageSettings.rumConfigCountryOverride}`);
    if (pageSettings.rumConfigStateOverride) qs.push(`s=${pageSettings.rumConfigStateOverride}`);
    if (pageSettings.rumConfigASNOverride) qs.push(`a=${pageSettings.rumConfigASNOverride}`);
    if (pageSettings.blockedReferrer) qs.push(`blocked-referrer=${pageSettings.blockedReferrer}`);
    return `${sessionConfigOrigin}/v3/config?${qs.join("&")}`;
}



const $d5e9170cded5c976$export$217954215557ef60 = (d, di)=>new $d5e9170cded5c976$var$CalculatorImpl(d, di);
class $d5e9170cded5c976$var$CalculatorImpl {
    /**
   * @param distribution A specification for the desired distribution of
   * fuzziness modifiers. Passing an empty array results in no fuzziness
   * being applied when the caller invokes `calculate` on the instance.
   */ constructor(_dependencies, distribution){
        this._dependencies = _dependencies;
        const iterator = {
            *[Symbol.iterator] () {
                for(let i = 0; i < distribution.length; i++){
                    const [instances, numerator, denominatorStart, denominatorEnd] = distribution[i];
                    for(let denominator = denominatorStart; denominator < denominatorEnd; denominator++){
                        const value = numerator / denominator;
                        for(let i = 0; i < instances; i++)yield value;
                    }
                }
            }
        };
        this._fuzzinessModifiers = new Float32Array(iterator);
    }
    /**
   * Calculate a number of milliseconds based on a target rate per hour,
   * applying a fuzziness modifier if the instance was given a specification.
   * @param hourlyRate The base hourly rate. May be capped if maxHourlyRate
   * has been set.
   */ calculateInterval(hourlyRate) {
        // Cap hourly rate if max has been set.
        const actualHourlyRate = this._dependencies.maxHourlyRate.value > 0 ? Math.min(hourlyRate, this._dependencies.maxHourlyRate.value) : hourlyRate;
        this._dependencies.outputToConsole((0, $f50e7fcb55f78359$export$afb6987cdf6e791e).debug, ()=>{
            const capDetail = hourlyRate == actualHourlyRate ? `hourly rate not capped` : `hourly rate capped at ${actualHourlyRate} from ${hourlyRate}`;
            return `Calculating interval (${capDetail})`;
        });
        const intervalInHours = 1 / actualHourlyRate;
        const MILLISECONDS_PER_HOUR = 3.6e6;
        const intervalInMilliseconds = intervalInHours * MILLISECONDS_PER_HOUR;
        const modifier = 0 < this._fuzzinessModifiers.length ? this._fuzzinessModifiers[Math.floor(this._dependencies.newRandomNumber((0, $f50e7fcb55f78359$export$327a1cd96f38a882)) * this._fuzzinessModifiers.length)] : 1;
        return Math.floor(intervalInMilliseconds * modifier);
    }
}





const $6ec91d2da3f52757$export$2a792d30f2eaf681 = (d)=>new $6ec91d2da3f52757$var$SchedulerImpl(d);
const $6ec91d2da3f52757$var$newFutureMeasurementMessage = (dopplerPlatformID, after)=>`Measuring ${dopplerPlatformID} after ${after}`;
const $6ec91d2da3f52757$var$newQueuedMeasurementsLogMessage = (due, toQueue, now)=>{
    const getMeasurementLogLine = (scheduleRecord)=>// eslint-disable-next-line max-len
        `${scheduleRecord.testObjectConfig.dopplerPlatformID} (${scheduleRecord.testObjectConfig.testObjectSize})`;
    const messageBuffer = [
        `Measurements due at ${now}:`
    ];
    messageBuffer.push(...due.map((scheduleRecord)=>getMeasurementLogLine(scheduleRecord)));
    messageBuffer.push("\nMeasurements to queue:");
    messageBuffer.push(...toQueue.map((scheduleRecord)=>getMeasurementLogLine(scheduleRecord)));
    return messageBuffer.join("\n");
};
const $6ec91d2da3f52757$var$newDifferenceInTargetFrequencyDetectedMessage = (dopplerPlatformID, from, to)=>// eslint-disable-next-line max-len
    `Difference detected in target frequency for ${dopplerPlatformID} (from: ${from}; to: ${to})`;
const $6ec91d2da3f52757$var$newScheduleDiagnosticsMessage = (schedule, at)=>schedule.reduce((result, scheduleRecord)=>{
        const scheduleInfo = scheduleRecord.scheduledMeasurementInfo;
        const id = scheduleRecord.testObjectConfig.dopplerPlatformID;
        result.push(scheduleInfo ? `${id} will be measured after ${scheduleInfo.measureAfter}` : `${id} currently unscheduled`);
        return result;
    }, [
        `Measurement Scheduler Diagnostics as of ${at}`
    ]).join("\n");
const $6ec91d2da3f52757$var$newMeasurementSkippedMessage = (dopplerPlatformID)=>`Skipping measurement for ${dopplerPlatformID} (measurements disabled)`;
const $6ec91d2da3f52757$var$newSessionConfigStalenessCheckDiagnosticMessage = (age, maxAge)=>`Session configuration staleness check (age: ${age}, max age: ${maxAge})`;
class $6ec91d2da3f52757$var$SchedulerImpl {
    constructor(_dependencies){
        this._dependencies = _dependencies;
        this._scheduleRecords = [];
        this._schedulerLocked = false;
    }
    _sortScheduleRecords() {
        this._scheduleRecords.sort((left, right)=>// Put unscheduled ones first
            !left.scheduledMeasurementInfo && !right.scheduledMeasurementInfo ? 0 : !left.scheduledMeasurementInfo ? -1 : !right.scheduledMeasurementInfo ? 1 : left.scheduledMeasurementInfo.measureAfter < right.scheduledMeasurementInfo.measureAfter ? -1 : left.scheduledMeasurementInfo.measureAfter > right.scheduledMeasurementInfo.measureAfter ? 1 : 0);
    }
    /**
   * Called when a change occurs that may affect one or more existing scheduled
   * measurements.
   */ reschedule() {
        this._dependencies.outputToConsole((0, $f50e7fcb55f78359$export$afb6987cdf6e791e).info, ()=>"Rescheduling (max target frequency " + this._dependencies.maxTargetFrequency.value + ")");
        const now = this._dependencies.newDate((0, $f50e7fcb55f78359$export$97c749ae9b458ac4));
        this._scheduleRecords.forEach((record)=>{
            // This is handled similar to how updatePopulation (re-)schedules a measurement
            // when the test object configuration changes.
            const scheduleInfo = record.scheduledMeasurementInfo;
            const startingFrom = scheduleInfo ? scheduleInfo.lastScheduledAt : now;
            // If a measurement was already scheduled, it gets rescheduled now.
            record.scheduledMeasurementInfo = {
                lastScheduledAt: now,
                measureAfter: new Date(startingFrom.getTime() + this._dependencies.intervalCalculator.calculateInterval(record.testObjectConfig.targetFrequency))
            };
        });
        // Keep the schedule records sorted
        this._sortScheduleRecords();
        this.outputDiagnosticMessage();
    }
    run() {
        this._dependencies.outputToConsole((0, $f50e7fcb55f78359$export$afb6987cdf6e791e).debug, ()=>`Scheduler run ${this._dependencies.newDate((0, $f50e7fcb55f78359$export$6f89989572f60f10))}`);
        if (!this._schedulerLocked) {
            this._schedulerLocked = true;
            const unlock = ()=>{
                this._schedulerLocked = false;
            };
            const makeSkipMeasurementExecutor = (scheduler, scheduleRecord)=>{
                return {
                    execute: ()=>{
                        scheduler._dependencies.outputToConsole((0, $f50e7fcb55f78359$export$afb6987cdf6e791e).debug, ()=>$6ec91d2da3f52757$var$newMeasurementSkippedMessage(scheduleRecord.testObjectConfig.dopplerPlatformID));
                        scheduler.scheduleNextMeasurement(scheduleRecord.testObjectConfig);
                        scheduler.outputDiagnosticMessage();
                        return Promise.resolve();
                    }
                };
            };
            const sessionConfigIsStale = (now, lastUpdatedAt, maxAgeInMilliseconds)=>{
                const diffInMilliseconds = now.valueOf() - lastUpdatedAt.valueOf();
                this._dependencies.outputToConsole((0, $f50e7fcb55f78359$export$afb6987cdf6e791e).debug, ()=>$6ec91d2da3f52757$var$newSessionConfigStalenessCheckDiagnosticMessage(diffInMilliseconds, maxAgeInMilliseconds));
                return diffInMilliseconds > maxAgeInMilliseconds;
            };
            const now = this._dependencies.newDate((0, $f50e7fcb55f78359$export$6f89989572f60f10));
            const sessionConfigLastUpdatedAt = this._dependencies.runtimeValues.sessionConfigLastUpdatedAt;
            if (!sessionConfigLastUpdatedAt || sessionConfigIsStale(now, sessionConfigLastUpdatedAt, // N minutes x 60 sec/min x 1000 ms/sec
            3000000)) {
                // Put measurements on pause until after the next sessconf refresh
                this._dependencies.outputToConsole((0, $f50e7fcb55f78359$export$afb6987cdf6e791e).info, ()=>"Measurements paused");
                unlock();
                return;
            }
            const measurementsDue = this._scheduleRecords.filter((schedulerRecord)=>schedulerRecord.scheduledMeasurementInfo && now > schedulerRecord.scheduledMeasurementInfo.measureAfter);
            if (measurementsDue.length) {
                // Cap the number of measurements per interval
                const maxMeasurementsPerInterval = 3;
                const measurementsToQueue = measurementsDue.slice(0, maxMeasurementsPerInterval);
                this._dependencies.outputToConsole((0, $f50e7fcb55f78359$export$afb6987cdf6e791e).debug, ()=>$6ec91d2da3f52757$var$newQueuedMeasurementsLogMessage(measurementsDue, measurementsToQueue, now));
                (0, $d4057b2940f42917$export$d7cb46a4e2f04c4f)(measurementsToQueue.map((scheduleRecord)=>this._dependencies.runtimeValues.measurementsEnabled ? (0, $2d6f60ca72098832$export$2e2bcd8739ae039)({
                        applicationEvents: this._dependencies.applicationEvents,
                        callClearTimeout: this._dependencies.callClearTimeout,
                        callSendBeacon: this._dependencies.callSendBeacon,
                        callSetTimeout: this._dependencies.callSetTimeout,
                        callClearResourceTimings: this._dependencies.callClearResourceTimings,
                        callFetch: this._dependencies.callFetch,
                        maxTargetFrequency: this._dependencies.maxTargetFrequency,
                        measurementScheduler: this,
                        newAbortController: this._dependencies.newAbortController,
                        newDate: this._dependencies.newDate,
                        newEpochTimestamp: this._dependencies.newEpochTimestamp,
                        newMonotonicTimestamp: this._dependencies.newMonotonicTimestamp,
                        newRandomNumber: this._dependencies.newRandomNumber,
                        outputToConsole: this._dependencies.outputToConsole,
                        performanceEntryAwaitTimeouts: this._dependencies.performanceEntryAwaitTimeouts,
                        performanceEntryManager: this._dependencies.performanceEntryManager,
                        runtimeValues: this._dependencies.runtimeValues
                    }, scheduleRecord.testObjectConfig, scheduleRecord.sessionMetadata) : makeSkipMeasurementExecutor(this, scheduleRecord))).then(unlock, unlock);
            } else unlock();
        } else this._dependencies.outputToConsole((0, $f50e7fcb55f78359$export$afb6987cdf6e791e).debug, ()=>"Skipping run because the scheduler is locked");
    }
    _scheduleMeasurement(testObjectConfig, immediate, depID) {
        const record = this._scheduleRecords.find((scheduleRecord)=>$6ec91d2da3f52757$var$matchTestObjectConfigIDs(scheduleRecord.testObjectConfig, testObjectConfig));
        if (record) {
            const now = this._dependencies.newDate(depID);
            const when = immediate ? now : new Date(now.getTime() + // Calculate delay in milliseconds
            this._dependencies.intervalCalculator.calculateInterval(record.testObjectConfig.targetFrequency));
            record.scheduledMeasurementInfo = {
                lastScheduledAt: now,
                measureAfter: when
            };
            // Keep the schedule records sorted
            this._sortScheduleRecords();
            const scheduleInfo = record.scheduledMeasurementInfo;
            if (scheduleInfo) this._dependencies.outputToConsole((0, $f50e7fcb55f78359$export$afb6987cdf6e791e).debug, ()=>$6ec91d2da3f52757$var$newFutureMeasurementMessage(testObjectConfig.dopplerPlatformID, scheduleInfo.measureAfter));
        }
    }
    scheduleNextMeasurement(testObjectConfig) {
        this._scheduleMeasurement(testObjectConfig, false, (0, $f50e7fcb55f78359$export$f995f08cb8d14b60));
    }
    scheduleNextMeasurementSoon(testObjectConfig) {
        this._scheduleMeasurement(testObjectConfig, true, (0, $f50e7fcb55f78359$export$e08a09aba61f8577));
    }
    initializePopulation(population, sessionMetadata, skipScheduling) {
        const skipSet = new Set(skipScheduling);
        this._scheduleRecords.push(...population.map((testObjectConfig)=>({
                testObjectConfig: testObjectConfig,
                sessionMetadata: sessionMetadata
            })));
        const now = this._dependencies.newDate((0, $f50e7fcb55f78359$export$350c6c4438936d6f));
        this._scheduleRecords.forEach((schedulerRecord)=>{
            const testObjectConfig = schedulerRecord.testObjectConfig;
            if (!skipSet.has(testObjectConfig)) {
                const delayInMilliseconds = this._dependencies.intervalCalculator.calculateInterval(testObjectConfig.targetFrequency);
                schedulerRecord.scheduledMeasurementInfo = {
                    lastScheduledAt: now,
                    // Not a bug since this invocation of new Date is deterministic
                    measureAfter: new Date(now.getTime() + delayInMilliseconds)
                };
                const scheduleInfo = schedulerRecord.scheduledMeasurementInfo;
                if (scheduleInfo) this._dependencies.outputToConsole((0, $f50e7fcb55f78359$export$afb6987cdf6e791e).debug, ()=>$6ec91d2da3f52757$var$newFutureMeasurementMessage(testObjectConfig.dopplerPlatformID, scheduleInfo.measureAfter));
            }
        });
        // Keep the schedule records sorted
        this._sortScheduleRecords();
    }
    /**
   * Update the test object population after a session configuration refresh.
   */ updatePopulation(population, sessionMetadata) {
        const calculateDelayInMilliseconds = (targetFrequency)=>this._dependencies.intervalCalculator.calculateInterval(targetFrequency);
        // Remove test objects no longer configured
        this._scheduleRecords = this._scheduleRecords.filter((scheduleRecord)=>population.some((incomingTestObjectConfig)=>$6ec91d2da3f52757$var$matchTestObjectConfigIDs(incomingTestObjectConfig, scheduleRecord.testObjectConfig)));
        const now = this._dependencies.newDate((0, $f50e7fcb55f78359$export$6362c2d955c1b09));
        population.forEach((incomingTestObjectConfig)=>{
            const record = this._scheduleRecords.find((scheduleRecord)=>$6ec91d2da3f52757$var$matchTestObjectConfigIDs(scheduleRecord.testObjectConfig, incomingTestObjectConfig));
            if (record) {
                // Update the existing record's configuration but only change
                // the scheduled information if the target frequency has changed
                const targetFrequencyChanged = record.testObjectConfig.targetFrequency !== incomingTestObjectConfig.targetFrequency;
                if (targetFrequencyChanged) this._dependencies.outputToConsole((0, $f50e7fcb55f78359$export$afb6987cdf6e791e).debug, ()=>$6ec91d2da3f52757$var$newDifferenceInTargetFrequencyDetectedMessage(incomingTestObjectConfig.dopplerPlatformID, record.testObjectConfig.targetFrequency, incomingTestObjectConfig.targetFrequency));
                record.testObjectConfig = incomingTestObjectConfig;
                record.sessionMetadata = sessionMetadata;
                const scheduleInfo = record.scheduledMeasurementInfo;
                if (!scheduleInfo || scheduleInfo && targetFrequencyChanged) {
                    const startingFrom = scheduleInfo ? scheduleInfo.lastScheduledAt : now;
                    record.scheduledMeasurementInfo = {
                        lastScheduledAt: now,
                        measureAfter: new Date(startingFrom.getTime() + calculateDelayInMilliseconds(incomingTestObjectConfig.targetFrequency))
                    };
                }
            } else this._scheduleRecords.push({
                testObjectConfig: incomingTestObjectConfig,
                sessionMetadata: sessionMetadata,
                scheduledMeasurementInfo: {
                    lastScheduledAt: now,
                    measureAfter: new Date(now.getTime() + calculateDelayInMilliseconds(incomingTestObjectConfig.targetFrequency))
                }
            });
        });
        // Keep the schedule records sorted
        this._sortScheduleRecords();
        this.outputDiagnosticMessage();
    }
    outputDiagnosticMessage() {
        this._dependencies.outputToConsole((0, $f50e7fcb55f78359$export$afb6987cdf6e791e).debug, ()=>$6ec91d2da3f52757$var$newScheduleDiagnosticsMessage(this._scheduleRecords, this._dependencies.newDate((0, $f50e7fcb55f78359$export$72c899c492056cc))));
    }
}
function $6ec91d2da3f52757$var$matchTestObjectConfigIDs(first, second) {
    return first.dopplerPlatformID === second.dopplerPlatformID && first.testObjectSize === second.testObjectSize;
}


function $1e1ae07069a7f4d4$export$2e2bcd8739ae039(value, lowerBound, upperBound) {
    return Math.max(Math.min(value, upperBound), lowerBound);
}


const $584fc5da9d233385$export$c1bafa21ac0d57e3 = (s)=>new $584fc5da9d233385$var$PageSettingsImpl(s);
class $584fc5da9d233385$var$PageSettingsImpl {
    constructor(source){
        /* eslint-disable @typescript-eslint/dot-notation */ this._applicationEventsBeaconInterval = source["applicationEventsBeaconInterval"];
        this._applicationLoggingEndpoint = source["applicationLoggingEndpoint"];
        this._blockedReferrer = source["blockedReferrer"];
        this._consoleLogLevel = source["consoleLogLevel"];
        this._dnsClientInfoSamplePct = source["dnsClientInfoSamplePct"];
        this._dopplerBeaconEndpoint = source["dopplerBeaconEndpoint"];
        this._measurementStartDelay = source["measurementStartDelay"];
        this._rumConfigCountryOverride = source["rumConfigCountryOverride"];
        this._rumConfigStateOverride = source["rumConfigStateOverride"];
        this._rumConfigASNOverride = source["rumConfigASNOverride"];
        this._schedulerRunInterval = source["schedulerRunInterval"];
        this._sessionConfigDelay = source["sessionConfigDelay"];
        this._sessionConfigOrigin = source["sessionConfigOrigin"];
        const tempSessionRefreshInterval = source["sessionRefreshInterval"];
        /* eslint-enable @typescript-eslint/dot-notation */ this._sessionRefreshInterval = typeof tempSessionRefreshInterval === "number" ? (0, $1e1ae07069a7f4d4$export$2e2bcd8739ae039)(tempSessionRefreshInterval, 1, 60) : undefined;
    }
    get consoleLogLevel() {
        return this._consoleLogLevel;
    }
    get applicationEventsBeaconInterval() {
        return this._applicationEventsBeaconInterval;
    }
    get applicationLoggingEndpoint() {
        return this._applicationLoggingEndpoint;
    }
    get blockedReferrer() {
        return this._blockedReferrer;
    }
    get sessionConfigDelay() {
        return this._sessionConfigDelay;
    }
    get measurementStartDelay() {
        return this._measurementStartDelay;
    }
    get sessionRefreshInterval() {
        return this._sessionRefreshInterval;
    }
    get dnsClientInfoSamplePct() {
        return this._dnsClientInfoSamplePct;
    }
    get dopplerBeaconEndpoint() {
        return this._dopplerBeaconEndpoint;
    }
    get schedulerRunInterval() {
        return this._schedulerRunInterval;
    }
    get sessionConfigOrigin() {
        return this._sessionConfigOrigin;
    }
    get rumConfigCountryOverride() {
        return this._rumConfigCountryOverride;
    }
    get rumConfigStateOverride() {
        return this._rumConfigStateOverride;
    }
    get rumConfigASNOverride() {
        return this._rumConfigASNOverride;
    }
}


const $b958a46160f62d1f$export$7a089005b53e5cd4 = ()=>new $b958a46160f62d1f$var$RuntimeValuesImpl();
class $b958a46160f62d1f$var$RuntimeValuesImpl {
    constructor(){
        this._applicationEventsBeaconIntervalID = undefined;
        this._applicationEventsBeaconIntervalInMilliseconds = undefined;
        this._disallowedNetworks = [];
        this._lastReadBeaconContinent = undefined;
        this._lastReadBeaconCountry = undefined;
        this._lastReadBeaconState = undefined;
        this._lastReadBeaconAsn = undefined;
        this._lastReadSessConfHeaderContinent = undefined;
        this._lastReadSessConfHeaderCountry = undefined;
        this._lastReadSessConfHeaderState = undefined;
        this._lastReadSessConfHeaderAsn = undefined;
        this._measurementsEnabled = false;
        this._resolverIP = undefined;
        this._schedulerRunIntervalID = undefined;
        this._schedulerRunIntervalInMilliseconds = undefined;
        this._sessionConfigLastUpdatedAt = undefined;
        this._sessionConfigRefreshIntervalID = undefined;
        this._sessionRefreshDelayInMilliseconds = undefined;
        this._sessionStartTimestamp = undefined;
        this._sessionUUID = undefined;
    }
    get disallowedNetworks() {
        return this._disallowedNetworks;
    }
    set disallowedNetworks(value) {
        this._disallowedNetworks = value;
    }
    get applicationEventsBeaconIntervalID() {
        return this._applicationEventsBeaconIntervalID;
    }
    set applicationEventsBeaconIntervalID(value) {
        this._applicationEventsBeaconIntervalID = value;
    }
    get applicationEventsBeaconIntervalInMilliseconds() {
        return this._applicationEventsBeaconIntervalInMilliseconds;
    }
    set applicationEventsBeaconIntervalInMilliseconds(value) {
        this._applicationEventsBeaconIntervalInMilliseconds = value;
    }
    get lastReadBeaconContinent() {
        return this._lastReadBeaconContinent;
    }
    set lastReadBeaconContinent(value) {
        this._lastReadBeaconContinent = value;
    }
    get lastReadBeaconCountry() {
        return this._lastReadBeaconCountry;
    }
    set lastReadBeaconCountry(value) {
        this._lastReadBeaconCountry = value;
    }
    get lastReadBeaconState() {
        return this._lastReadBeaconState;
    }
    set lastReadBeaconState(value) {
        this._lastReadBeaconState = value;
    }
    get lastReadBeaconAsn() {
        return this._lastReadBeaconAsn;
    }
    set lastReadBeaconAsn(value) {
        this._lastReadBeaconAsn = value;
    }
    get lastReadSessConfHeaderContinent() {
        return this._lastReadSessConfHeaderContinent;
    }
    set lastReadSessConfHeaderContinent(value) {
        this._lastReadSessConfHeaderContinent = value;
    }
    get lastReadSessConfHeaderCountry() {
        return this._lastReadSessConfHeaderCountry;
    }
    set lastReadSessConfHeaderCountry(value) {
        this._lastReadSessConfHeaderCountry = value;
    }
    get lastReadSessConfHeaderState() {
        return this._lastReadSessConfHeaderState;
    }
    set lastReadSessConfHeaderState(value) {
        this._lastReadSessConfHeaderState = value;
    }
    get lastReadSessConfHeaderAsn() {
        return this._lastReadSessConfHeaderAsn;
    }
    set lastReadSessConfHeaderAsn(value) {
        this._lastReadSessConfHeaderAsn = value;
    }
    get measurementsEnabled() {
        return this._measurementsEnabled;
    }
    set measurementsEnabled(value) {
        this._measurementsEnabled = value;
    }
    get resolverIP() {
        return this._resolverIP;
    }
    set resolverIP(value) {
        this._resolverIP = value;
    }
    get schedulerRunIntervalID() {
        return this._schedulerRunIntervalID;
    }
    set schedulerRunIntervalID(value) {
        this._schedulerRunIntervalID = value;
    }
    get schedulerRunIntervalInMilliseconds() {
        return this._schedulerRunIntervalInMilliseconds;
    }
    set schedulerRunIntervalInMilliseconds(value) {
        this._schedulerRunIntervalInMilliseconds = value;
    }
    get sessionConfigLastUpdatedAt() {
        return this._sessionConfigLastUpdatedAt;
    }
    set sessionConfigLastUpdatedAt(value) {
        this._sessionConfigLastUpdatedAt = value;
    }
    get sessionConfigRefreshIntervalID() {
        return this._sessionConfigRefreshIntervalID;
    }
    set sessionConfigRefreshIntervalID(value) {
        this._sessionConfigRefreshIntervalID = value;
    }
    get sessionRefreshDelayInMilliseconds() {
        return this._sessionRefreshDelayInMilliseconds;
    }
    set sessionRefreshDelayInMilliseconds(value) {
        this._sessionRefreshDelayInMilliseconds = value;
    }
    get sessionStartTimestamp() {
        return this._sessionStartTimestamp;
    }
    set sessionStartTimestamp(value) {
        this._sessionStartTimestamp = value;
    }
    get sessionUUID() {
        return this._sessionUUID;
    }
    set sessionUUID(value) {
        this._sessionUUID = value;
    }
    updateMeasurementsEnabledForNetwork(asn) {
        this._measurementsEnabled = !this._disallowedNetworks.includes(asn);
    }
}



function $e82742756830c4e4$export$2e2bcd8739ae039(allowedLogLevel, messageLogLevel) {
    const toLower = allowedLogLevel.toLowerCase();
    return toLower === "error" ? messageLogLevel === (0, $f50e7fcb55f78359$export$afb6987cdf6e791e).error : toLower === "warn" ? messageLogLevel === (0, $f50e7fcb55f78359$export$afb6987cdf6e791e).error || messageLogLevel === (0, $f50e7fcb55f78359$export$afb6987cdf6e791e).warn : toLower === "info" ? messageLogLevel === (0, $f50e7fcb55f78359$export$afb6987cdf6e791e).error || messageLogLevel === (0, $f50e7fcb55f78359$export$afb6987cdf6e791e).warn || messageLogLevel === (0, $f50e7fcb55f78359$export$afb6987cdf6e791e).info : toLower === "debug" ? messageLogLevel === (0, $f50e7fcb55f78359$export$afb6987cdf6e791e).error || messageLogLevel === (0, $f50e7fcb55f78359$export$afb6987cdf6e791e).warn || messageLogLevel === (0, $f50e7fcb55f78359$export$afb6987cdf6e791e).info || messageLogLevel === (0, $f50e7fcb55f78359$export$afb6987cdf6e791e).debug : false;
}


/////////////////////////////////////////////////////////////////////////////////
/* UAParser.js v1.0.35
   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
   MIT License */ /*
   Detect Browser, Engine, OS, CPU, and Device type/model from User-Agent data.
   Supports browser & node.js environment.
   Demo   : https://faisalman.github.io/ua-parser-js
   Source : https://github.com/faisalman/ua-parser-js */ /////////////////////////////////////////////////////////////////////////////////
// (function (window, undefined) {
"use strict";
//////////////
// Constants
/////////////
var $ec0ce4c7e70d591f$var$LIBVERSION = "1.0.35", $ec0ce4c7e70d591f$var$EMPTY = "", $ec0ce4c7e70d591f$var$UNKNOWN = "?", $ec0ce4c7e70d591f$var$FUNC_TYPE = "function", $ec0ce4c7e70d591f$var$UNDEF_TYPE = "undefined", $ec0ce4c7e70d591f$var$OBJ_TYPE = "object", $ec0ce4c7e70d591f$var$STR_TYPE = "string", $ec0ce4c7e70d591f$var$MAJOR = "major", $ec0ce4c7e70d591f$var$MODEL = "model", $ec0ce4c7e70d591f$var$NAME = "name", $ec0ce4c7e70d591f$var$TYPE = "type", $ec0ce4c7e70d591f$var$VENDOR = "vendor", $ec0ce4c7e70d591f$var$VERSION = "version", $ec0ce4c7e70d591f$var$ARCHITECTURE = "architecture", $ec0ce4c7e70d591f$var$CONSOLE = "console", $ec0ce4c7e70d591f$var$MOBILE = "mobile", $ec0ce4c7e70d591f$var$TABLET = "tablet", $ec0ce4c7e70d591f$var$SMARTTV = "smarttv", $ec0ce4c7e70d591f$var$WEARABLE = "wearable", $ec0ce4c7e70d591f$var$EMBEDDED = "embedded", $ec0ce4c7e70d591f$var$UA_MAX_LENGTH = 350;
var $ec0ce4c7e70d591f$var$AMAZON = "Amazon", $ec0ce4c7e70d591f$var$APPLE = "Apple", $ec0ce4c7e70d591f$var$ASUS = "ASUS", $ec0ce4c7e70d591f$var$BLACKBERRY = "BlackBerry", $ec0ce4c7e70d591f$var$BROWSER = "Browser", $ec0ce4c7e70d591f$var$CHROME = "Chrome", $ec0ce4c7e70d591f$var$EDGE = "Edge", $ec0ce4c7e70d591f$var$FIREFOX = "Firefox", $ec0ce4c7e70d591f$var$GOOGLE = "Google", $ec0ce4c7e70d591f$var$HUAWEI = "Huawei", $ec0ce4c7e70d591f$var$LG = "LG", $ec0ce4c7e70d591f$var$MICROSOFT = "Microsoft", $ec0ce4c7e70d591f$var$MOTOROLA = "Motorola", $ec0ce4c7e70d591f$var$OPERA = "Opera", $ec0ce4c7e70d591f$var$SAMSUNG = "Samsung", $ec0ce4c7e70d591f$var$SHARP = "Sharp", $ec0ce4c7e70d591f$var$SONY = "Sony", $ec0ce4c7e70d591f$var$VIERA = "Viera", $ec0ce4c7e70d591f$var$XIAOMI = "Xiaomi", $ec0ce4c7e70d591f$var$ZEBRA = "Zebra", $ec0ce4c7e70d591f$var$FACEBOOK = "Facebook", $ec0ce4c7e70d591f$var$CHROMIUM_OS = "Chromium OS", $ec0ce4c7e70d591f$var$MAC_OS = "Mac OS";
///////////
// Helper
//////////
var $ec0ce4c7e70d591f$var$extend = function(regexes, extensions) {
    var mergedRegexes = {};
    for(var i in regexes)if (extensions[i] && extensions[i].length % 2 === 0) mergedRegexes[i] = extensions[i].concat(regexes[i]);
    else mergedRegexes[i] = regexes[i];
    return mergedRegexes;
}, $ec0ce4c7e70d591f$var$enumerize = function(arr) {
    var enums = {};
    for(var i = 0; i < arr.length; i++)enums[arr[i].toUpperCase()] = arr[i];
    return enums;
}, $ec0ce4c7e70d591f$var$has = function(str1, str2) {
    return typeof str1 === $ec0ce4c7e70d591f$var$STR_TYPE ? $ec0ce4c7e70d591f$var$lowerize(str2).indexOf($ec0ce4c7e70d591f$var$lowerize(str1)) !== -1 : false;
}, $ec0ce4c7e70d591f$var$lowerize = function(str) {
    return str.toLowerCase();
}, $ec0ce4c7e70d591f$var$majorize = function(version) {
    return typeof version === $ec0ce4c7e70d591f$var$STR_TYPE ? version.replace(/[^\d\.]/g, $ec0ce4c7e70d591f$var$EMPTY).split(".")[0] : undefined;
}, $ec0ce4c7e70d591f$var$trim = function(str, len) {
    if (typeof str === $ec0ce4c7e70d591f$var$STR_TYPE) {
        str = str.replace(/^\s\s*/, $ec0ce4c7e70d591f$var$EMPTY);
        return typeof len === $ec0ce4c7e70d591f$var$UNDEF_TYPE ? str : str.substring(0, $ec0ce4c7e70d591f$var$UA_MAX_LENGTH);
    }
};
///////////////
// Map helper
//////////////
var $ec0ce4c7e70d591f$var$rgxMapper = function(ua, arrays) {
    var i = 0, j, k, p, q, matches, match;
    // loop through all regexes maps
    while(i < arrays.length && !matches){
        var regex = arrays[i], props = arrays[i + 1] // odd sequence (1,3,5,..)
        ;
        j = k = 0;
        // try matching uastring with regexes
        while(j < regex.length && !matches){
            if (!regex[j]) break;
            matches = regex[j++].exec(ua);
            if (!!matches) for(p = 0; p < props.length; p++){
                match = matches[++k];
                q = props[p];
                // check if given property is actually array
                if (typeof q === $ec0ce4c7e70d591f$var$OBJ_TYPE && q.length > 0) {
                    if (q.length === 2) {
                        if (typeof q[1] == $ec0ce4c7e70d591f$var$FUNC_TYPE) // assign modified match
                        this[q[0]] = q[1].call(this, match);
                        else // assign given value, ignore regex match
                        this[q[0]] = q[1];
                    } else if (q.length === 3) {
                        // check whether function or regex
                        if (typeof q[1] === $ec0ce4c7e70d591f$var$FUNC_TYPE && !(q[1].exec && q[1].test)) // call function (usually string mapper)
                        this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                        else // sanitize match using given regex
                        this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                    } else if (q.length === 4) this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                } else this[q] = match ? match : undefined;
            }
        }
        i += 2;
    }
}, $ec0ce4c7e70d591f$var$strMapper = function(str, map) {
    for(var i in map){
        // check if current value is array
        if (typeof map[i] === $ec0ce4c7e70d591f$var$OBJ_TYPE && map[i].length > 0) for(var j = 0; j < map[i].length; j++){
            if ($ec0ce4c7e70d591f$var$has(map[i][j], str)) return i === $ec0ce4c7e70d591f$var$UNKNOWN ? undefined : i;
        }
        else if ($ec0ce4c7e70d591f$var$has(map[i], str)) return i === $ec0ce4c7e70d591f$var$UNKNOWN ? undefined : i;
    }
    return str;
};
///////////////
// String map
//////////////
// Safari < 3.0
var $ec0ce4c7e70d591f$var$oldSafariMap = {
    "1.0": "/8",
    1.2: "/1",
    1.3: "/3",
    "2.0": "/412",
    "2.0.2": "/416",
    "2.0.3": "/417",
    "2.0.4": "/419",
    "?": "/"
}, $ec0ce4c7e70d591f$var$windowsVersionMap = {
    ME: "4.90",
    "NT 3.11": "NT3.51",
    "NT 4.0": "NT4.0",
    2000: "NT 5.0",
    XP: [
        "NT 5.1",
        "NT 5.2"
    ],
    Vista: "NT 6.0",
    7: "NT 6.1",
    8: "NT 6.2",
    8.1: "NT 6.3",
    10: [
        "NT 6.4",
        "NT 10.0"
    ],
    RT: "ARM"
};
//////////////
// Regex map
/////////////
var $ec0ce4c7e70d591f$var$regexes = {
    browser: [
        [
            /\b(?:crmo|crios)\/([\w\.]+)/i
        ],
        [
            $ec0ce4c7e70d591f$var$VERSION,
            [
                $ec0ce4c7e70d591f$var$NAME,
                "Chrome"
            ]
        ],
        [
            /edg(?:e|ios|a)?\/([\w\.]+)/i
        ],
        [
            $ec0ce4c7e70d591f$var$VERSION,
            [
                $ec0ce4c7e70d591f$var$NAME,
                "Edge"
            ]
        ],
        [
            // Presto based
            /(opera mini)\/([-\w\.]+)/i,
            /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
            /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
        ],
        [
            $ec0ce4c7e70d591f$var$NAME,
            $ec0ce4c7e70d591f$var$VERSION
        ],
        [
            /opios[\/ ]+([\w\.]+)/i
        ],
        [
            $ec0ce4c7e70d591f$var$VERSION,
            [
                $ec0ce4c7e70d591f$var$NAME,
                $ec0ce4c7e70d591f$var$OPERA + " Mini"
            ]
        ],
        [
            /\bopr\/([\w\.]+)/i
        ],
        [
            $ec0ce4c7e70d591f$var$VERSION,
            [
                $ec0ce4c7e70d591f$var$NAME,
                $ec0ce4c7e70d591f$var$OPERA
            ]
        ],
        [
            // Mixed
            /(kindle)\/([\w\.]+)/i,
            /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
            // Trident based
            /(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i,
            /(ba?idubrowser)[\/ ]?([\w\.]+)/i,
            /(?:ms|\()(ie) ([\w\.]+)/i,
            // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
            /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
            // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
            /(heytap|ovi)browser\/([\d\.]+)/i,
            /(weibo)__([\d\.]+)/i
        ],
        [
            $ec0ce4c7e70d591f$var$NAME,
            $ec0ce4c7e70d591f$var$VERSION
        ],
        [
            /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
        ],
        [
            $ec0ce4c7e70d591f$var$VERSION,
            [
                $ec0ce4c7e70d591f$var$NAME,
                "UC" + $ec0ce4c7e70d591f$var$BROWSER
            ]
        ],
        [
            /microm.+\bqbcore\/([\w\.]+)/i,
            /\bqbcore\/([\w\.]+).+microm/i
        ],
        [
            $ec0ce4c7e70d591f$var$VERSION,
            [
                $ec0ce4c7e70d591f$var$NAME,
                "WeChat(Win) Desktop"
            ]
        ],
        [
            /micromessenger\/([\w\.]+)/i
        ],
        [
            $ec0ce4c7e70d591f$var$VERSION,
            [
                $ec0ce4c7e70d591f$var$NAME,
                "WeChat"
            ]
        ],
        [
            /konqueror\/([\w\.]+)/i
        ],
        [
            $ec0ce4c7e70d591f$var$VERSION,
            [
                $ec0ce4c7e70d591f$var$NAME,
                "Konqueror"
            ]
        ],
        [
            /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
        ],
        [
            $ec0ce4c7e70d591f$var$VERSION,
            [
                $ec0ce4c7e70d591f$var$NAME,
                "IE"
            ]
        ],
        [
            /ya(?:search)?browser\/([\w\.]+)/i
        ],
        [
            $ec0ce4c7e70d591f$var$VERSION,
            [
                $ec0ce4c7e70d591f$var$NAME,
                "Yandex"
            ]
        ],
        [
            /(avast|avg)\/([\w\.]+)/i
        ],
        [
            [
                $ec0ce4c7e70d591f$var$NAME,
                /(.+)/,
                "$1 Secure " + $ec0ce4c7e70d591f$var$BROWSER
            ],
            $ec0ce4c7e70d591f$var$VERSION
        ],
        [
            /\bfocus\/([\w\.]+)/i
        ],
        [
            $ec0ce4c7e70d591f$var$VERSION,
            [
                $ec0ce4c7e70d591f$var$NAME,
                $ec0ce4c7e70d591f$var$FIREFOX + " Focus"
            ]
        ],
        [
            /\bopt\/([\w\.]+)/i
        ],
        [
            $ec0ce4c7e70d591f$var$VERSION,
            [
                $ec0ce4c7e70d591f$var$NAME,
                $ec0ce4c7e70d591f$var$OPERA + " Touch"
            ]
        ],
        [
            /coc_coc\w+\/([\w\.]+)/i
        ],
        [
            $ec0ce4c7e70d591f$var$VERSION,
            [
                $ec0ce4c7e70d591f$var$NAME,
                "Coc Coc"
            ]
        ],
        [
            /dolfin\/([\w\.]+)/i
        ],
        [
            $ec0ce4c7e70d591f$var$VERSION,
            [
                $ec0ce4c7e70d591f$var$NAME,
                "Dolphin"
            ]
        ],
        [
            /coast\/([\w\.]+)/i
        ],
        [
            $ec0ce4c7e70d591f$var$VERSION,
            [
                $ec0ce4c7e70d591f$var$NAME,
                $ec0ce4c7e70d591f$var$OPERA + " Coast"
            ]
        ],
        [
            /miuibrowser\/([\w\.]+)/i
        ],
        [
            $ec0ce4c7e70d591f$var$VERSION,
            [
                $ec0ce4c7e70d591f$var$NAME,
                "MIUI " + $ec0ce4c7e70d591f$var$BROWSER
            ]
        ],
        [
            /fxios\/([-\w\.]+)/i
        ],
        [
            $ec0ce4c7e70d591f$var$VERSION,
            [
                $ec0ce4c7e70d591f$var$NAME,
                $ec0ce4c7e70d591f$var$FIREFOX
            ]
        ],
        [
            /\bqihu|(qi?ho?o?|360)browser/i
        ],
        [
            [
                $ec0ce4c7e70d591f$var$NAME,
                "360 " + $ec0ce4c7e70d591f$var$BROWSER
            ]
        ],
        [
            /(oculus|samsung|sailfish|huawei)browser\/([\w\.]+)/i
        ],
        [
            [
                $ec0ce4c7e70d591f$var$NAME,
                /(.+)/,
                "$1 " + $ec0ce4c7e70d591f$var$BROWSER
            ],
            $ec0ce4c7e70d591f$var$VERSION
        ],
        [
            // Oculus/Samsung/Sailfish/Huawei Browser
            /(comodo_dragon)\/([\w\.]+)/i
        ],
        [
            [
                $ec0ce4c7e70d591f$var$NAME,
                /_/g,
                " "
            ],
            $ec0ce4c7e70d591f$var$VERSION
        ],
        [
            /(electron)\/([\w\.]+) safari/i,
            /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
            /m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i
        ],
        [
            $ec0ce4c7e70d591f$var$NAME,
            $ec0ce4c7e70d591f$var$VERSION
        ],
        [
            /(metasr)[\/ ]?([\w\.]+)/i,
            /(lbbrowser)/i,
            /\[(linkedin)app\]/i
        ],
        [
            $ec0ce4c7e70d591f$var$NAME
        ],
        [
            // WebView
            /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
        ],
        [
            [
                $ec0ce4c7e70d591f$var$NAME,
                $ec0ce4c7e70d591f$var$FACEBOOK
            ],
            $ec0ce4c7e70d591f$var$VERSION
        ],
        [
            /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
            /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
            /safari (line)\/([\w\.]+)/i,
            /\b(line)\/([\w\.]+)\/iab/i,
            /(chromium|instagram)[\/ ]([-\w\.]+)/i
        ],
        [
            $ec0ce4c7e70d591f$var$NAME,
            $ec0ce4c7e70d591f$var$VERSION
        ],
        [
            /\bgsa\/([\w\.]+) .*safari\//i
        ],
        [
            $ec0ce4c7e70d591f$var$VERSION,
            [
                $ec0ce4c7e70d591f$var$NAME,
                "GSA"
            ]
        ],
        [
            /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
        ],
        [
            $ec0ce4c7e70d591f$var$VERSION,
            [
                $ec0ce4c7e70d591f$var$NAME,
                "TikTok"
            ]
        ],
        [
            /headlesschrome(?:\/([\w\.]+)| )/i
        ],
        [
            $ec0ce4c7e70d591f$var$VERSION,
            [
                $ec0ce4c7e70d591f$var$NAME,
                $ec0ce4c7e70d591f$var$CHROME + " Headless"
            ]
        ],
        [
            / wv\).+(chrome)\/([\w\.]+)/i
        ],
        [
            [
                $ec0ce4c7e70d591f$var$NAME,
                $ec0ce4c7e70d591f$var$CHROME + " WebView"
            ],
            $ec0ce4c7e70d591f$var$VERSION
        ],
        [
            /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
        ],
        [
            $ec0ce4c7e70d591f$var$VERSION,
            [
                $ec0ce4c7e70d591f$var$NAME,
                "Android " + $ec0ce4c7e70d591f$var$BROWSER
            ]
        ],
        [
            /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
        ],
        [
            $ec0ce4c7e70d591f$var$NAME,
            $ec0ce4c7e70d591f$var$VERSION
        ],
        [
            /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i
        ],
        [
            $ec0ce4c7e70d591f$var$VERSION,
            [
                $ec0ce4c7e70d591f$var$NAME,
                "Mobile Safari"
            ]
        ],
        [
            /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i
        ],
        [
            $ec0ce4c7e70d591f$var$VERSION,
            $ec0ce4c7e70d591f$var$NAME
        ],
        [
            /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
        ],
        [
            $ec0ce4c7e70d591f$var$NAME,
            [
                $ec0ce4c7e70d591f$var$VERSION,
                $ec0ce4c7e70d591f$var$strMapper,
                $ec0ce4c7e70d591f$var$oldSafariMap
            ]
        ],
        [
            /(webkit|khtml)\/([\w\.]+)/i
        ],
        [
            $ec0ce4c7e70d591f$var$NAME,
            $ec0ce4c7e70d591f$var$VERSION
        ],
        [
            // Gecko based
            /(navigator|netscape\d?)\/([-\w\.]+)/i
        ],
        [
            [
                $ec0ce4c7e70d591f$var$NAME,
                "Netscape"
            ],
            $ec0ce4c7e70d591f$var$VERSION
        ],
        [
            /mobile vr; rv:([\w\.]+)\).+firefox/i
        ],
        [
            $ec0ce4c7e70d591f$var$VERSION,
            [
                $ec0ce4c7e70d591f$var$NAME,
                $ec0ce4c7e70d591f$var$FIREFOX + " Reality"
            ]
        ],
        [
            /ekiohf.+(flow)\/([\w\.]+)/i,
            /(swiftfox)/i,
            /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
            // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
            /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
            // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
            /(firefox)\/([\w\.]+)/i,
            /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
            // Other
            /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
            // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
            /(links) \(([\w\.]+)/i,
            /panasonic;(viera)/i
        ],
        [
            $ec0ce4c7e70d591f$var$NAME,
            $ec0ce4c7e70d591f$var$VERSION
        ],
        [
            /(cobalt)\/([\w\.]+)/i
        ],
        [
            $ec0ce4c7e70d591f$var$NAME,
            [
                $ec0ce4c7e70d591f$var$VERSION,
                /master.|lts./,
                ""
            ]
        ]
    ],
    cpu: [
        [
            /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i
        ],
        [
            [
                $ec0ce4c7e70d591f$var$ARCHITECTURE,
                "amd64"
            ]
        ],
        [
            /(ia32(?=;))/i
        ],
        [
            [
                $ec0ce4c7e70d591f$var$ARCHITECTURE,
                $ec0ce4c7e70d591f$var$lowerize
            ]
        ],
        [
            /((?:i[346]|x)86)[;\)]/i
        ],
        [
            [
                $ec0ce4c7e70d591f$var$ARCHITECTURE,
                "ia32"
            ]
        ],
        [
            /\b(aarch64|arm(v?8e?l?|_?64))\b/i
        ],
        [
            [
                $ec0ce4c7e70d591f$var$ARCHITECTURE,
                "arm64"
            ]
        ],
        [
            /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i
        ],
        [
            [
                $ec0ce4c7e70d591f$var$ARCHITECTURE,
                "armhf"
            ]
        ],
        [
            // PocketPC mistakenly identified as PowerPC
            /windows (ce|mobile); ppc;/i
        ],
        [
            [
                $ec0ce4c7e70d591f$var$ARCHITECTURE,
                "arm"
            ]
        ],
        [
            /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i
        ],
        [
            [
                $ec0ce4c7e70d591f$var$ARCHITECTURE,
                /ower/,
                $ec0ce4c7e70d591f$var$EMPTY,
                $ec0ce4c7e70d591f$var$lowerize
            ]
        ],
        [
            /(sun4\w)[;\)]/i
        ],
        [
            [
                $ec0ce4c7e70d591f$var$ARCHITECTURE,
                "sparc"
            ]
        ],
        [
            /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
        ],
        [
            [
                $ec0ce4c7e70d591f$var$ARCHITECTURE,
                $ec0ce4c7e70d591f$var$lowerize
            ]
        ]
    ],
    device: [
        [
            //////////////////////////
            // MOBILES & TABLETS
            /////////////////////////
            // Samsung
            /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                $ec0ce4c7e70d591f$var$SAMSUNG
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$TABLET
            ]
        ],
        [
            /\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
            /samsung[- ]([-\w]+)/i,
            /sec-(sgh\w+)/i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                $ec0ce4c7e70d591f$var$SAMSUNG
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$MOBILE
            ]
        ],
        [
            // Apple
            /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                $ec0ce4c7e70d591f$var$APPLE
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$MOBILE
            ]
        ],
        [
            /\((ipad);[-\w\),; ]+apple/i,
            /applecoremedia\/[\w\.]+ \((ipad)/i,
            /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                $ec0ce4c7e70d591f$var$APPLE
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$TABLET
            ]
        ],
        [
            /(macintosh);/i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                $ec0ce4c7e70d591f$var$APPLE
            ]
        ],
        [
            // Sharp
            /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                $ec0ce4c7e70d591f$var$SHARP
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$MOBILE
            ]
        ],
        [
            // Huawei
            /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                $ec0ce4c7e70d591f$var$HUAWEI
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$TABLET
            ]
        ],
        [
            /(?:huawei|honor)([-\w ]+)[;\)]/i,
            /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                $ec0ce4c7e70d591f$var$HUAWEI
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$MOBILE
            ]
        ],
        [
            // Xiaomi
            /\b(poco[\w ]+)(?: bui|\))/i,
            /\b; (\w+) build\/hm\1/i,
            /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
            /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
            /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i
        ],
        [
            [
                $ec0ce4c7e70d591f$var$MODEL,
                /_/g,
                " "
            ],
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                $ec0ce4c7e70d591f$var$XIAOMI
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$MOBILE
            ]
        ],
        [
            /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i
        ],
        [
            [
                $ec0ce4c7e70d591f$var$MODEL,
                /_/g,
                " "
            ],
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                $ec0ce4c7e70d591f$var$XIAOMI
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$TABLET
            ]
        ],
        [
            // OPPO
            /; (\w+) bui.+ oppo/i,
            /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                "OPPO"
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$MOBILE
            ]
        ],
        [
            // Vivo
            /vivo (\w+)(?: bui|\))/i,
            /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                "Vivo"
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$MOBILE
            ]
        ],
        [
            // Realme
            /\b(rmx[12]\d{3})(?: bui|;|\))/i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                "Realme"
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$MOBILE
            ]
        ],
        [
            // Motorola
            /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
            /\bmot(?:orola)?[- ](\w*)/i,
            /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                $ec0ce4c7e70d591f$var$MOTOROLA
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$MOBILE
            ]
        ],
        [
            /\b(mz60\d|xoom[2 ]{0,2}) build\//i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                $ec0ce4c7e70d591f$var$MOTOROLA
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$TABLET
            ]
        ],
        [
            // LG
            /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                $ec0ce4c7e70d591f$var$LG
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$TABLET
            ]
        ],
        [
            /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
            /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
            /\blg-?([\d\w]+) bui/i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                $ec0ce4c7e70d591f$var$LG
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$MOBILE
            ]
        ],
        [
            // Lenovo
            /(ideatab[-\w ]+)/i,
            /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                "Lenovo"
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$TABLET
            ]
        ],
        [
            // Nokia
            /(?:maemo|nokia).*(n900|lumia \d+)/i,
            /nokia[-_ ]?([-\w\.]*)/i
        ],
        [
            [
                $ec0ce4c7e70d591f$var$MODEL,
                /_/g,
                " "
            ],
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                "Nokia"
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$MOBILE
            ]
        ],
        [
            // Google
            /(pixel c)\b/i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                $ec0ce4c7e70d591f$var$GOOGLE
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$TABLET
            ]
        ],
        [
            /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                $ec0ce4c7e70d591f$var$GOOGLE
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$MOBILE
            ]
        ],
        [
            // Sony
            /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                $ec0ce4c7e70d591f$var$SONY
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$MOBILE
            ]
        ],
        [
            /sony tablet [ps]/i,
            /\b(?:sony)?sgp\w+(?: bui|\))/i
        ],
        [
            [
                $ec0ce4c7e70d591f$var$MODEL,
                "Xperia Tablet"
            ],
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                $ec0ce4c7e70d591f$var$SONY
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$TABLET
            ]
        ],
        [
            // OnePlus
            / (kb2005|in20[12]5|be20[12][59])\b/i,
            /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                "OnePlus"
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$MOBILE
            ]
        ],
        [
            // Amazon
            /(alexa)webm/i,
            /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,
            /(kf[a-z]+)( bui|\)).+silk\//i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                $ec0ce4c7e70d591f$var$AMAZON
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$TABLET
            ]
        ],
        [
            /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
        ],
        [
            [
                $ec0ce4c7e70d591f$var$MODEL,
                /(.+)/g,
                "Fire Phone $1"
            ],
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                $ec0ce4c7e70d591f$var$AMAZON
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$MOBILE
            ]
        ],
        [
            // BlackBerry
            /(playbook);[-\w\),; ]+(rim)/i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            $ec0ce4c7e70d591f$var$VENDOR,
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$TABLET
            ]
        ],
        [
            /\b((?:bb[a-f]|st[hv])100-\d)/i,
            /\(bb10; (\w+)/i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                $ec0ce4c7e70d591f$var$BLACKBERRY
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$MOBILE
            ]
        ],
        [
            // Asus
            /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                $ec0ce4c7e70d591f$var$ASUS
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$TABLET
            ]
        ],
        [
            / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                $ec0ce4c7e70d591f$var$ASUS
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$MOBILE
            ]
        ],
        [
            // HTC
            /(nexus 9)/i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                "HTC"
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$TABLET
            ]
        ],
        [
            /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
            // ZTE
            /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
            /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
        ],
        [
            $ec0ce4c7e70d591f$var$VENDOR,
            [
                $ec0ce4c7e70d591f$var$MODEL,
                /_/g,
                " "
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$MOBILE
            ]
        ],
        [
            // Acer
            /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                "Acer"
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$TABLET
            ]
        ],
        [
            // Meizu
            /droid.+; (m[1-5] note) bui/i,
            /\bmz-([-\w]{2,})/i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                "Meizu"
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$MOBILE
            ]
        ],
        [
            // MIXED
            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i,
            // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
            /(hp) ([\w ]+\w)/i,
            /(asus)-?(\w+)/i,
            /(microsoft); (lumia[\w ]+)/i,
            /(lenovo)[-_ ]?([-\w]+)/i,
            /(jolla)/i,
            /(oppo) ?([\w ]+) bui/i
        ],
        [
            $ec0ce4c7e70d591f$var$VENDOR,
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$MOBILE
            ]
        ],
        [
            /(kobo)\s(ereader|touch)/i,
            /(archos) (gamepad2?)/i,
            /(hp).+(touchpad(?!.+tablet)|tablet)/i,
            /(kindle)\/([\w\.]+)/i,
            /(nook)[\w ]+build\/(\w+)/i,
            /(dell) (strea[kpr\d ]*[\dko])/i,
            /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
            /(trinity)[- ]*(t\d{3}) bui/i,
            /(gigaset)[- ]+(q\w{1,9}) bui/i,
            /(vodafone) ([\w ]+)(?:\)| bui)/i
        ],
        [
            $ec0ce4c7e70d591f$var$VENDOR,
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$TABLET
            ]
        ],
        [
            /(surface duo)/i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                $ec0ce4c7e70d591f$var$MICROSOFT
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$TABLET
            ]
        ],
        [
            /droid [\d\.]+; (fp\du?)(?: b|\))/i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                "Fairphone"
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$MOBILE
            ]
        ],
        [
            /(u304aa)/i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                "AT&T"
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$MOBILE
            ]
        ],
        [
            /\bsie-(\w*)/i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                "Siemens"
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$MOBILE
            ]
        ],
        [
            /\b(rct\w+) b/i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                "RCA"
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$TABLET
            ]
        ],
        [
            /\b(venue[\d ]{2,7}) b/i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                "Dell"
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$TABLET
            ]
        ],
        [
            /\b(q(?:mv|ta)\w+) b/i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                "Verizon"
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$TABLET
            ]
        ],
        [
            /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                "Barnes & Noble"
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$TABLET
            ]
        ],
        [
            /\b(tm\d{3}\w+) b/i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                "NuVision"
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$TABLET
            ]
        ],
        [
            /\b(k88) b/i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                "ZTE"
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$TABLET
            ]
        ],
        [
            /\b(nx\d{3}j) b/i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                "ZTE"
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$MOBILE
            ]
        ],
        [
            /\b(gen\d{3}) b.+49h/i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                "Swiss"
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$MOBILE
            ]
        ],
        [
            /\b(zur\d{3}) b/i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                "Swiss"
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$TABLET
            ]
        ],
        [
            /\b((zeki)?tb.*\b) b/i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                "Zeki"
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$TABLET
            ]
        ],
        [
            /\b([yr]\d{2}) b/i,
            /\b(dragon[- ]+touch |dt)(\w{5}) b/i
        ],
        [
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                "Dragon Touch"
            ],
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$TABLET
            ]
        ],
        [
            /\b(ns-?\w{0,9}) b/i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                "Insignia"
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$TABLET
            ]
        ],
        [
            /\b((nxa|next)-?\w{0,9}) b/i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                "NextBook"
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$TABLET
            ]
        ],
        [
            /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
        ],
        [
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                "Voice"
            ],
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$MOBILE
            ]
        ],
        [
            /\b(lvtel\-)?(v1[12]) b/i
        ],
        [
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                "LvTel"
            ],
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$MOBILE
            ]
        ],
        [
            /\b(ph-1) /i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                "Essential"
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$MOBILE
            ]
        ],
        [
            /\b(v(100md|700na|7011|917g).*\b) b/i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                "Envizen"
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$TABLET
            ]
        ],
        [
            /\b(trio[-\w\. ]+) b/i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                "MachSpeed"
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$TABLET
            ]
        ],
        [
            /\btu_(1491) b/i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                "Rotor"
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$TABLET
            ]
        ],
        [
            /(shield[\w ]+) b/i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                "Nvidia"
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$TABLET
            ]
        ],
        [
            /(sprint) (\w+)/i
        ],
        [
            $ec0ce4c7e70d591f$var$VENDOR,
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$MOBILE
            ]
        ],
        [
            /(kin\.[onetw]{3})/i
        ],
        [
            [
                $ec0ce4c7e70d591f$var$MODEL,
                /\./g,
                " "
            ],
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                $ec0ce4c7e70d591f$var$MICROSOFT
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$MOBILE
            ]
        ],
        [
            /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                $ec0ce4c7e70d591f$var$ZEBRA
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$TABLET
            ]
        ],
        [
            /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                $ec0ce4c7e70d591f$var$ZEBRA
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$MOBILE
            ]
        ],
        [
            ///////////////////
            // SMARTTVS
            ///////////////////
            /smart-tv.+(samsung)/i
        ],
        [
            $ec0ce4c7e70d591f$var$VENDOR,
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$SMARTTV
            ]
        ],
        [
            /hbbtv.+maple;(\d+)/i
        ],
        [
            [
                $ec0ce4c7e70d591f$var$MODEL,
                /^/,
                "SmartTV"
            ],
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                $ec0ce4c7e70d591f$var$SAMSUNG
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$SMARTTV
            ]
        ],
        [
            /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
        ],
        [
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                $ec0ce4c7e70d591f$var$LG
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$SMARTTV
            ]
        ],
        [
            /(apple) ?tv/i
        ],
        [
            $ec0ce4c7e70d591f$var$VENDOR,
            [
                $ec0ce4c7e70d591f$var$MODEL,
                $ec0ce4c7e70d591f$var$APPLE + " TV"
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$SMARTTV
            ]
        ],
        [
            /crkey/i
        ],
        [
            [
                $ec0ce4c7e70d591f$var$MODEL,
                $ec0ce4c7e70d591f$var$CHROME + "cast"
            ],
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                $ec0ce4c7e70d591f$var$GOOGLE
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$SMARTTV
            ]
        ],
        [
            /droid.+aft(\w)( bui|\))/i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                $ec0ce4c7e70d591f$var$AMAZON
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$SMARTTV
            ]
        ],
        [
            /\(dtv[\);].+(aquos)/i,
            /(aquos-tv[\w ]+)\)/i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                $ec0ce4c7e70d591f$var$SHARP
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$SMARTTV
            ]
        ],
        [
            /(bravia[\w ]+)( bui|\))/i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                $ec0ce4c7e70d591f$var$SONY
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$SMARTTV
            ]
        ],
        [
            /(mitv-\w{5}) bui/i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                $ec0ce4c7e70d591f$var$XIAOMI
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$SMARTTV
            ]
        ],
        [
            /Hbbtv.*(technisat) (.*);/i
        ],
        [
            $ec0ce4c7e70d591f$var$VENDOR,
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$SMARTTV
            ]
        ],
        [
            /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
            /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
        ],
        [
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                $ec0ce4c7e70d591f$var$trim
            ],
            [
                $ec0ce4c7e70d591f$var$MODEL,
                $ec0ce4c7e70d591f$var$trim
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$SMARTTV
            ]
        ],
        [
            /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
        ],
        [
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$SMARTTV
            ]
        ],
        [
            ///////////////////
            // CONSOLES
            ///////////////////
            /(ouya)/i,
            /(nintendo) ([wids3utch]+)/i
        ],
        [
            $ec0ce4c7e70d591f$var$VENDOR,
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$CONSOLE
            ]
        ],
        [
            /droid.+; (shield) bui/i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                "Nvidia"
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$CONSOLE
            ]
        ],
        [
            /(playstation [345portablevi]+)/i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                $ec0ce4c7e70d591f$var$SONY
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$CONSOLE
            ]
        ],
        [
            /\b(xbox(?: one)?(?!; xbox))[\); ]/i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                $ec0ce4c7e70d591f$var$MICROSOFT
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$CONSOLE
            ]
        ],
        [
            ///////////////////
            // WEARABLES
            ///////////////////
            /((pebble))app/i
        ],
        [
            $ec0ce4c7e70d591f$var$VENDOR,
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$WEARABLE
            ]
        ],
        [
            /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                $ec0ce4c7e70d591f$var$APPLE
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$WEARABLE
            ]
        ],
        [
            /droid.+; (glass) \d/i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                $ec0ce4c7e70d591f$var$GOOGLE
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$WEARABLE
            ]
        ],
        [
            /droid.+; (wt63?0{2,3})\)/i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                $ec0ce4c7e70d591f$var$ZEBRA
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$WEARABLE
            ]
        ],
        [
            /(quest( 2| pro)?)/i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                $ec0ce4c7e70d591f$var$FACEBOOK
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$WEARABLE
            ]
        ],
        [
            ///////////////////
            // EMBEDDED
            ///////////////////
            /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
        ],
        [
            $ec0ce4c7e70d591f$var$VENDOR,
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$EMBEDDED
            ]
        ],
        [
            /(aeobc)\b/i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                $ec0ce4c7e70d591f$var$AMAZON
            ],
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$EMBEDDED
            ]
        ],
        [
            ////////////////////
            // MIXED (GENERIC)
            ///////////////////
            /droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$MOBILE
            ]
        ],
        [
            /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$TABLET
            ]
        ],
        [
            /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
        ],
        [
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$TABLET
            ]
        ],
        [
            /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
        ],
        [
            [
                $ec0ce4c7e70d591f$var$TYPE,
                $ec0ce4c7e70d591f$var$MOBILE
            ]
        ],
        [
            /(android[-\w\. ]{0,9});.+buil/i
        ],
        [
            $ec0ce4c7e70d591f$var$MODEL,
            [
                $ec0ce4c7e70d591f$var$VENDOR,
                "Generic"
            ]
        ]
    ],
    engine: [
        [
            /windows.+ edge\/([\w\.]+)/i
        ],
        [
            $ec0ce4c7e70d591f$var$VERSION,
            [
                $ec0ce4c7e70d591f$var$NAME,
                $ec0ce4c7e70d591f$var$EDGE + "HTML"
            ]
        ],
        [
            /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
        ],
        [
            $ec0ce4c7e70d591f$var$VERSION,
            [
                $ec0ce4c7e70d591f$var$NAME,
                "Blink"
            ]
        ],
        [
            /(presto)\/([\w\.]+)/i,
            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
            /ekioh(flow)\/([\w\.]+)/i,
            /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
            /(icab)[\/ ]([23]\.[\d\.]+)/i,
            /\b(libweb)/i
        ],
        [
            $ec0ce4c7e70d591f$var$NAME,
            $ec0ce4c7e70d591f$var$VERSION
        ],
        [
            /rv\:([\w\.]{1,9})\b.+(gecko)/i
        ],
        [
            $ec0ce4c7e70d591f$var$VERSION,
            $ec0ce4c7e70d591f$var$NAME
        ]
    ],
    os: [
        [
            // Windows
            /microsoft (windows) (vista|xp)/i
        ],
        [
            $ec0ce4c7e70d591f$var$NAME,
            $ec0ce4c7e70d591f$var$VERSION
        ],
        [
            /(windows) nt 6\.2; (arm)/i,
            /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i,
            /(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i
        ],
        [
            $ec0ce4c7e70d591f$var$NAME,
            [
                $ec0ce4c7e70d591f$var$VERSION,
                $ec0ce4c7e70d591f$var$strMapper,
                $ec0ce4c7e70d591f$var$windowsVersionMap
            ]
        ],
        [
            /(win(?=3|9|n)|win 9x )([nt\d\.]+)/i
        ],
        [
            [
                $ec0ce4c7e70d591f$var$NAME,
                "Windows"
            ],
            [
                $ec0ce4c7e70d591f$var$VERSION,
                $ec0ce4c7e70d591f$var$strMapper,
                $ec0ce4c7e70d591f$var$windowsVersionMap
            ]
        ],
        [
            // iOS/macOS
            /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
            /ios;fbsv\/([\d\.]+)/i,
            /cfnetwork\/.+darwin/i
        ],
        [
            [
                $ec0ce4c7e70d591f$var$VERSION,
                /_/g,
                "."
            ],
            [
                $ec0ce4c7e70d591f$var$NAME,
                "iOS"
            ]
        ],
        [
            /(mac os x) ?([\w\. ]*)/i,
            /(macintosh|mac_powerpc\b)(?!.+haiku)/i
        ],
        [
            [
                $ec0ce4c7e70d591f$var$NAME,
                $ec0ce4c7e70d591f$var$MAC_OS
            ],
            [
                $ec0ce4c7e70d591f$var$VERSION,
                /_/g,
                "."
            ]
        ],
        [
            // Mobile OSes
            /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
        ],
        [
            $ec0ce4c7e70d591f$var$VERSION,
            $ec0ce4c7e70d591f$var$NAME
        ],
        [
            // Android/WebOS/QNX/Bada/RIM/Maemo/MeeGo/Sailfish OS
            /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
            /(blackberry)\w*\/([\w\.]*)/i,
            /(tizen|kaios)[\/ ]([\w\.]+)/i,
            /\((series40);/i
        ],
        [
            $ec0ce4c7e70d591f$var$NAME,
            $ec0ce4c7e70d591f$var$VERSION
        ],
        [
            /\(bb(10);/i
        ],
        [
            $ec0ce4c7e70d591f$var$VERSION,
            [
                $ec0ce4c7e70d591f$var$NAME,
                $ec0ce4c7e70d591f$var$BLACKBERRY
            ]
        ],
        [
            /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i
        ],
        [
            $ec0ce4c7e70d591f$var$VERSION,
            [
                $ec0ce4c7e70d591f$var$NAME,
                "Symbian"
            ]
        ],
        [
            /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
        ],
        [
            $ec0ce4c7e70d591f$var$VERSION,
            [
                $ec0ce4c7e70d591f$var$NAME,
                $ec0ce4c7e70d591f$var$FIREFOX + " OS"
            ]
        ],
        [
            /web0s;.+rt(tv)/i,
            /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
        ],
        [
            $ec0ce4c7e70d591f$var$VERSION,
            [
                $ec0ce4c7e70d591f$var$NAME,
                "webOS"
            ]
        ],
        [
            /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
        ],
        [
            $ec0ce4c7e70d591f$var$VERSION,
            [
                $ec0ce4c7e70d591f$var$NAME,
                "watchOS"
            ]
        ],
        [
            // Google Chromecast
            /crkey\/([\d\.]+)/i
        ],
        [
            $ec0ce4c7e70d591f$var$VERSION,
            [
                $ec0ce4c7e70d591f$var$NAME,
                $ec0ce4c7e70d591f$var$CHROME + "cast"
            ]
        ],
        [
            /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
        ],
        [
            [
                $ec0ce4c7e70d591f$var$NAME,
                $ec0ce4c7e70d591f$var$CHROMIUM_OS
            ],
            $ec0ce4c7e70d591f$var$VERSION
        ],
        [
            // Smart TVs
            /panasonic;(viera)/i,
            /(netrange)mmh/i,
            /(nettv)\/(\d+\.[\w\.]+)/i,
            // Console
            /(nintendo|playstation) ([wids345portablevuch]+)/i,
            /(xbox); +xbox ([^\);]+)/i,
            // Other
            /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
            /(mint)[\/\(\) ]?(\w*)/i,
            /(mageia|vectorlinux)[; ]/i,
            /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
            // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
            /(hurd|linux) ?([\w\.]*)/i,
            /(gnu) ?([\w\.]*)/i,
            /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
            /(haiku) (\w+)/i
        ],
        [
            $ec0ce4c7e70d591f$var$NAME,
            $ec0ce4c7e70d591f$var$VERSION
        ],
        [
            /(sunos) ?([\w\.\d]*)/i
        ],
        [
            [
                $ec0ce4c7e70d591f$var$NAME,
                "Solaris"
            ],
            $ec0ce4c7e70d591f$var$VERSION
        ],
        [
            /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
            /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
            /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
            /(unix) ?([\w\.]*)/i
        ],
        [
            $ec0ce4c7e70d591f$var$NAME,
            $ec0ce4c7e70d591f$var$VERSION
        ]
    ]
};
function $ec0ce4c7e70d591f$export$96faab28bec89d1f(ua, extensions) {
    //var UAParser = function (ua, extensions) {
    if (typeof ua === $ec0ce4c7e70d591f$var$OBJ_TYPE) {
        extensions = ua;
        ua = undefined;
    }
    if (!(this instanceof $ec0ce4c7e70d591f$export$96faab28bec89d1f)) return new $ec0ce4c7e70d591f$export$96faab28bec89d1f(ua, extensions).getResult();
    var _navigator = typeof window !== $ec0ce4c7e70d591f$var$UNDEF_TYPE && window.navigator ? window.navigator : undefined;
    var _ua = ua || (_navigator && _navigator.userAgent ? _navigator.userAgent : $ec0ce4c7e70d591f$var$EMPTY);
    var _uach = _navigator && _navigator.userAgentData ? _navigator.userAgentData : undefined;
    var _rgxmap = extensions ? $ec0ce4c7e70d591f$var$extend($ec0ce4c7e70d591f$var$regexes, extensions) : $ec0ce4c7e70d591f$var$regexes;
    var _isSelfNav = _navigator && _navigator.userAgent == _ua;
    this.getBrowser = function() {
        var _browser = {};
        _browser[$ec0ce4c7e70d591f$var$NAME] = undefined;
        _browser[$ec0ce4c7e70d591f$var$VERSION] = undefined;
        $ec0ce4c7e70d591f$var$rgxMapper.call(_browser, _ua, _rgxmap.browser);
        _browser[$ec0ce4c7e70d591f$var$MAJOR] = $ec0ce4c7e70d591f$var$majorize(_browser[$ec0ce4c7e70d591f$var$VERSION]);
        // Brave-specific detection
        if (_isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave == $ec0ce4c7e70d591f$var$FUNC_TYPE) _browser[$ec0ce4c7e70d591f$var$NAME] = "Brave";
        return _browser;
    };
    this.getCPU = function() {
        var _cpu = {};
        _cpu[$ec0ce4c7e70d591f$var$ARCHITECTURE] = undefined;
        $ec0ce4c7e70d591f$var$rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
        return _cpu;
    };
    this.getDevice = function() {
        var _device = {};
        _device[$ec0ce4c7e70d591f$var$VENDOR] = undefined;
        _device[$ec0ce4c7e70d591f$var$MODEL] = undefined;
        _device[$ec0ce4c7e70d591f$var$TYPE] = undefined;
        $ec0ce4c7e70d591f$var$rgxMapper.call(_device, _ua, _rgxmap.device);
        if (_isSelfNav && !_device[$ec0ce4c7e70d591f$var$TYPE] && _uach && _uach.mobile) _device[$ec0ce4c7e70d591f$var$TYPE] = $ec0ce4c7e70d591f$var$MOBILE;
        // iPadOS-specific detection: identified as Mac, but has some iOS-only properties
        if (_isSelfNav && _device[$ec0ce4c7e70d591f$var$MODEL] == "Macintosh" && _navigator && typeof _navigator.standalone !== $ec0ce4c7e70d591f$var$UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
            _device[$ec0ce4c7e70d591f$var$MODEL] = "iPad";
            _device[$ec0ce4c7e70d591f$var$TYPE] = $ec0ce4c7e70d591f$var$TABLET;
        }
        return _device;
    };
    this.getEngine = function() {
        var _engine = {};
        _engine[$ec0ce4c7e70d591f$var$NAME] = undefined;
        _engine[$ec0ce4c7e70d591f$var$VERSION] = undefined;
        $ec0ce4c7e70d591f$var$rgxMapper.call(_engine, _ua, _rgxmap.engine);
        return _engine;
    };
    this.getOS = function() {
        var _os = {};
        _os[$ec0ce4c7e70d591f$var$NAME] = undefined;
        _os[$ec0ce4c7e70d591f$var$VERSION] = undefined;
        $ec0ce4c7e70d591f$var$rgxMapper.call(_os, _ua, _rgxmap.os);
        if (_isSelfNav && !_os[$ec0ce4c7e70d591f$var$NAME] && _uach && _uach.platform != "Unknown") _os[$ec0ce4c7e70d591f$var$NAME] = _uach.platform.replace(/chrome os/i, $ec0ce4c7e70d591f$var$CHROMIUM_OS).replace(/macos/i, $ec0ce4c7e70d591f$var$MAC_OS) // backward compatibility
        ;
        return _os;
    };
    this.getResult = function() {
        return {
            ua: this.getUA(),
            browser: this.getBrowser(),
            engine: this.getEngine(),
            os: this.getOS(),
            device: this.getDevice(),
            cpu: this.getCPU()
        };
    };
    this.getUA = function() {
        return _ua;
    };
    this.setUA = function(ua) {
        _ua = typeof ua === $ec0ce4c7e70d591f$var$STR_TYPE && ua.length > $ec0ce4c7e70d591f$var$UA_MAX_LENGTH ? $ec0ce4c7e70d591f$var$trim(ua, $ec0ce4c7e70d591f$var$UA_MAX_LENGTH) : ua;
        return this;
    };
    this.setUA(_ua);
    return this;
}
$ec0ce4c7e70d591f$export$96faab28bec89d1f.VERSION = $ec0ce4c7e70d591f$var$LIBVERSION;
$ec0ce4c7e70d591f$export$96faab28bec89d1f.BROWSER = $ec0ce4c7e70d591f$var$enumerize([
    $ec0ce4c7e70d591f$var$NAME,
    $ec0ce4c7e70d591f$var$VERSION,
    $ec0ce4c7e70d591f$var$MAJOR
]);
$ec0ce4c7e70d591f$export$96faab28bec89d1f.CPU = $ec0ce4c7e70d591f$var$enumerize([
    $ec0ce4c7e70d591f$var$ARCHITECTURE
]);
$ec0ce4c7e70d591f$export$96faab28bec89d1f.DEVICE = $ec0ce4c7e70d591f$var$enumerize([
    $ec0ce4c7e70d591f$var$MODEL,
    $ec0ce4c7e70d591f$var$VENDOR,
    $ec0ce4c7e70d591f$var$TYPE,
    $ec0ce4c7e70d591f$var$CONSOLE,
    $ec0ce4c7e70d591f$var$MOBILE,
    $ec0ce4c7e70d591f$var$SMARTTV,
    $ec0ce4c7e70d591f$var$TABLET,
    $ec0ce4c7e70d591f$var$WEARABLE,
    $ec0ce4c7e70d591f$var$EMBEDDED
]);
$ec0ce4c7e70d591f$export$96faab28bec89d1f.ENGINE = $ec0ce4c7e70d591f$export$96faab28bec89d1f.OS = $ec0ce4c7e70d591f$var$enumerize([
    $ec0ce4c7e70d591f$var$NAME,
    $ec0ce4c7e70d591f$var$VERSION
]) ///////////
 // Export
 //////////
 // // check js environment
 // if (typeof(exports) !== UNDEF_TYPE) {
 //     // nodejs env
 //     if (typeof module !== UNDEF_TYPE && module.exports) {
 //         exports = module.exports = UAParser;
 //     }
 //     exports.UAParser = UAParser;
 // } else {
 //     // requirejs env (optional)
 //     if (typeof(define) === FUNC_TYPE && define.amd) {
 //         define(function () {
 //             return UAParser;
 //         });
 //     } else if (typeof window !== UNDEF_TYPE) {
 //         // browser env
 //         window.UAParser = UAParser;
 //     }
 // }
 // // jQuery/Zepto specific (optional)
 // // Note:
 // //   In AMD env the global scope should be kept clean, but jQuery is an exception.
 // //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
 // //   and we should catch that.
 // var $ = typeof window !== UNDEF_TYPE && (window.jQuery || window.Zepto);
 // if ($ && !$.ua) {
 //     var parser = new UAParser();
 //     $.ua = parser.getResult();
 //     $.ua.get = function () {
 //         return parser.getUA();
 //     };
 //     $.ua.set = function (ua) {
 //         parser.setUA(ua);
 //         var result = parser.getResult();
 //         for (var prop in result) {
 //             $.ua[prop] = result[prop];
 //         }
 //     };
 // }
 // })(typeof window === 'object' ? window : this);
;




const $95188f04a3735eeb$export$1515dac04e676674 = ()=>new $95188f04a3735eeb$var$ResettableEventCounterImpl();
class $95188f04a3735eeb$var$ResettableEventCounterImpl {
    constructor(){
        this._countOfEvents = 0;
    }
    add(count) {
        this._countOfEvents += count;
    }
    reset() {
        this._countOfEvents = 0;
    }
    get countOfEvents() {
        return this._countOfEvents;
    }
}


const $ce1b45ee30ce3a5a$var$myWindow = window;
const $ce1b45ee30ce3a5a$var$pageSettings = (0, $584fc5da9d233385$export$c1bafa21ac0d57e3)($ce1b45ee30ce3a5a$var$myWindow.__DOPPLER_PAGE_SETTINGS__ || {});
const $ce1b45ee30ce3a5a$var$newDate = (_depID)=>new Date();
/**
 * Returns the number of milliseconds elapsed since midnight 1/1/1970 UTC.
 * Callers may prefer this to `newDate` if they know they only need the epoch
 * timestamp.
 */ const $ce1b45ee30ce3a5a$var$newEpochTimestamp = (_depID)=>Date.now();
const $ce1b45ee30ce3a5a$var$newMonotonicTimestamp = (_depID)=>performance.now();
const $ce1b45ee30ce3a5a$var$newRandomNumber = (_depID)=>Math.random();
const $ce1b45ee30ce3a5a$var$callFetch = (url, options)=>fetch(url, options);
const $ce1b45ee30ce3a5a$var$callSendBeacon = (_depID, url)=>typeof navigator.sendBeacon === "function" ? navigator.sendBeacon(url) : false;
const $ce1b45ee30ce3a5a$var$callSetInterval = (_depID, fn, delay)=>{
    const arbitraryMinimumDelay = 4800;
    if (isNaN(delay) || delay < arbitraryMinimumDelay) throw new Error(`setInterval called with invalid interval value ${delay}`);
    return setInterval(fn, delay);
};
const $ce1b45ee30ce3a5a$var$callSetTimeout = (_depID, fn, timeout)=>setTimeout(fn, timeout);
const $ce1b45ee30ce3a5a$var$localOutputToConsole = (messageLogLevel, message)=>{
    /* eslint-disable no-console */ if (messageLogLevel === (0, $f50e7fcb55f78359$export$afb6987cdf6e791e).error) console.error(message);
    else if (messageLogLevel === (0, $f50e7fcb55f78359$export$afb6987cdf6e791e).warn) console.warn(message);
    else if (messageLogLevel === (0, $f50e7fcb55f78359$export$afb6987cdf6e791e).info) console.info(message);
    else if (messageLogLevel === (0, $f50e7fcb55f78359$export$afb6987cdf6e791e).debug) console.debug(message);
/* eslint-enable no-console */ };
const $ce1b45ee30ce3a5a$var$shouldOutputToConsole = (level)=>typeof $ce1b45ee30ce3a5a$var$pageSettings.consoleLogLevel === "string" ? (0, $e82742756830c4e4$export$2e2bcd8739ae039)($ce1b45ee30ce3a5a$var$pageSettings.consoleLogLevel, level) : false;
const $ce1b45ee30ce3a5a$var$outputToConsole = (messageLogLevel, callback)=>{
    if ($ce1b45ee30ce3a5a$var$shouldOutputToConsole(messageLogLevel)) $ce1b45ee30ce3a5a$var$localOutputToConsole(messageLogLevel, callback());
};
const $ce1b45ee30ce3a5a$var$runtimeValues = (0, $b958a46160f62d1f$export$7a089005b53e5cd4)();
const $ce1b45ee30ce3a5a$var$maxTargetFrequency = {
    value: 0
};
const $ce1b45ee30ce3a5a$var$applicationEvents = (0, $2945e13ce7899c45$export$f5922988a7d5ce84)({
    callSendBeaconWithData: (_depID, url, data)=>typeof navigator.sendBeacon === "function" ? navigator.sendBeacon(url, data) : false,
    outputToConsole: $ce1b45ee30ce3a5a$var$outputToConsole,
    runtimeValues: $ce1b45ee30ce3a5a$var$runtimeValues
}, // client version string
(0, $92e2aa6e01d15e04$export$2e2bcd8739ae039));
// Send one last application events beacon as the user leaves the page
window.addEventListener("beforeunload", ()=>{
    $ce1b45ee30ce3a5a$var$applicationEvents.beacon();
});
const $ce1b45ee30ce3a5a$var$performanceEntryManager = (0, $5d65dfadff0b8bf3$export$86e6d657b62cd9f6)({
    newDate: ()=>$ce1b45ee30ce3a5a$var$newDate((0, $f50e7fcb55f78359$export$c95076cb2f76f866)),
    newPerformanceObserver: (callback)=>new PerformanceObserver(callback)
});
const $ce1b45ee30ce3a5a$var$performanceEntryAwaitTimeouts = (0, $95188f04a3735eeb$export$1515dac04e676674)();
const $ce1b45ee30ce3a5a$var$intervalCalculator = (0, $d5e9170cded5c976$export$217954215557ef60)({
    maxHourlyRate: $ce1b45ee30ce3a5a$var$maxTargetFrequency,
    newRandomNumber: $ce1b45ee30ce3a5a$var$newRandomNumber,
    outputToConsole: $ce1b45ee30ce3a5a$var$outputToConsole
}, [
    [
        5,
        1000,
        801,
        850
    ],
    [
        7,
        1000,
        851,
        900
    ],
    [
        9,
        1000,
        901,
        950
    ],
    [
        10,
        1000,
        951,
        1000
    ],
    [
        10,
        1000,
        1001,
        1050
    ],
    [
        9,
        1000,
        1051,
        1100
    ],
    [
        7,
        1000,
        1101,
        1150
    ],
    [
        5,
        1000,
        1151,
        1200
    ]
]);
const $ce1b45ee30ce3a5a$var$measurementScheduler = (0, $6ec91d2da3f52757$export$2a792d30f2eaf681)({
    applicationEvents: $ce1b45ee30ce3a5a$var$applicationEvents,
    callSetTimeout: $ce1b45ee30ce3a5a$var$callSetTimeout,
    callSendBeacon: $ce1b45ee30ce3a5a$var$callSendBeacon,
    callClearResourceTimings: ()=>performance.clearResourceTimings(),
    callClearTimeout: (timeoutID)=>clearTimeout(timeoutID),
    callFetch: $ce1b45ee30ce3a5a$var$callFetch,
    intervalCalculator: $ce1b45ee30ce3a5a$var$intervalCalculator,
    maxTargetFrequency: $ce1b45ee30ce3a5a$var$maxTargetFrequency,
    newAbortController: ()=>new AbortController(),
    newDate: $ce1b45ee30ce3a5a$var$newDate,
    newEpochTimestamp: $ce1b45ee30ce3a5a$var$newEpochTimestamp,
    newMonotonicTimestamp: $ce1b45ee30ce3a5a$var$newMonotonicTimestamp,
    newRandomNumber: $ce1b45ee30ce3a5a$var$newRandomNumber,
    outputToConsole: $ce1b45ee30ce3a5a$var$outputToConsole,
    performanceEntryAwaitTimeouts: $ce1b45ee30ce3a5a$var$performanceEntryAwaitTimeouts,
    performanceEntryManager: $ce1b45ee30ce3a5a$var$performanceEntryManager,
    runtimeValues: $ce1b45ee30ce3a5a$var$runtimeValues
});
$ce1b45ee30ce3a5a$var$detectFeatures() && setTimeout(()=>(0, $d68b1039d176e4d9$export$889ea624f2cb2c57)({
        addDocumentReadyStateChangeListener: (callback)=>document.addEventListener("readystatechange", callback),
        applicationEvents: $ce1b45ee30ce3a5a$var$applicationEvents,
        callAbortSignalTimeout: (_depID, timeout)=>AbortSignal.timeout(timeout),
        callClearInterval: (_depID, intervalID)=>clearInterval(intervalID),
        callClearTimeout: (_depID, timeoutID)=>clearTimeout(timeoutID),
        callFetch: $ce1b45ee30ce3a5a$var$callFetch,
        callClearResourceTimings: ()=>performance.clearResourceTimings(),
        callSendBeacon: $ce1b45ee30ce3a5a$var$callSendBeacon,
        callSetInterval: $ce1b45ee30ce3a5a$var$callSetInterval,
        callSetTimeout: $ce1b45ee30ce3a5a$var$callSetTimeout,
        getDocumentReadyState: ()=>document.readyState,
        maxTargetFrequency: $ce1b45ee30ce3a5a$var$maxTargetFrequency,
        measurementScheduler: $ce1b45ee30ce3a5a$var$measurementScheduler,
        newAbortController: ()=>new AbortController(),
        newDate: $ce1b45ee30ce3a5a$var$newDate,
        newEpochTimestamp: $ce1b45ee30ce3a5a$var$newEpochTimestamp,
        newMonotonicTimestamp: $ce1b45ee30ce3a5a$var$newMonotonicTimestamp,
        newRandomNumber: $ce1b45ee30ce3a5a$var$newRandomNumber,
        newUUIDv4: ()=>(0, $4a74e7e99c2caeb6$export$2e2bcd8739ae039)(),
        outputToConsole: $ce1b45ee30ce3a5a$var$outputToConsole,
        performanceEntryAwaitTimeouts: $ce1b45ee30ce3a5a$var$performanceEntryAwaitTimeouts,
        performanceEntryManager: $ce1b45ee30ce3a5a$var$performanceEntryManager,
        runtimeValues: $ce1b45ee30ce3a5a$var$runtimeValues
    }, {
        sessionMetadata: $ce1b45ee30ce3a5a$var$newSessionMetadata(),
        sessionConfigURL: (0, $59daa7000386d092$export$d0181195b6bd7eda)($ce1b45ee30ce3a5a$var$pageSettings),
        pageSettings: $ce1b45ee30ce3a5a$var$pageSettings,
        clientInitializationEvent: $ce1b45ee30ce3a5a$var$applicationEvents.recordClientInitializedEvent($ce1b45ee30ce3a5a$var$newEpochTimestamp((0, $f50e7fcb55f78359$export$6b7aa691b2b53ea0)))
    }), (0, $59daa7000386d092$export$d9616f691092113d)(5000, $ce1b45ee30ce3a5a$var$pageSettings));
function $ce1b45ee30ce3a5a$var$newSessionMetadata() {
    const versionBits = (0, $92e2aa6e01d15e04$export$2e2bcd8739ae039).split(".");
    if (versionBits.length != 3 || Number.isNaN(parseInt(versionBits[0])) || Number.isNaN(parseInt(versionBits[1]))) throw new Error(`Invalid client version: ${(0, $92e2aa6e01d15e04$export$2e2bcd8739ae039)}`);
    const uaParser = new (0, $ec0ce4c7e70d591f$export$96faab28bec89d1f)();
    const uaParserResult = typeof uaParser.getResult == "function" ? uaParser.getResult() : {
        ua: navigator.userAgent,
        device: {},
        browser: {},
        os: {}
    };
    const browserMeta = {
        userAgent: uaParserResult.ua,
        deviceCategory: "web",
        device: uaParserResult.device,
        browser: uaParserResult.browser,
        os: uaParserResult.os
    };
    const [major, minor, patch] = versionBits;
    const result = {
        browserMeta: browserMeta,
        clientVersion: [
            major,
            minor,
            patch
        ]
    };
    return result;
}
function $ce1b45ee30ce3a5a$var$detectFeatures() {
    return typeof navigator.sendBeacon === "function" && typeof Promise.allSettled === "function" && typeof Array.prototype.flatMap === "function";
}

})();
//# sourceMappingURL=doppler.9a665cdd.min.js.map
